var fa = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Fr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var rt = { exports: {} }, va = {}, nr, da;
function re() {
  if (da) return nr;
  da = 1;
  var e = function(r) {
    return r && r.Math === Math && r;
  };
  return nr = // eslint-disable-next-line es/no-global-this -- safe
  e(typeof globalThis == "object" && globalThis) || e(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  e(typeof self == "object" && self) || e(typeof fa == "object" && fa) || e(typeof nr == "object" && nr) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || Function("return this")(), nr;
}
var tt, ha;
function Y() {
  return ha || (ha = 1, tt = function(e) {
    try {
      return !!e();
    } catch {
      return !0;
    }
  }), tt;
}
var it, ba;
function Nr() {
  if (ba) return it;
  ba = 1;
  var e = /* @__PURE__ */ Y();
  return it = !e(function() {
    var r = (function() {
    }).bind();
    return typeof r != "function" || r.hasOwnProperty("prototype");
  }), it;
}
var nt, ya;
function mc() {
  if (ya) return nt;
  ya = 1;
  var e = /* @__PURE__ */ Nr(), r = Function.prototype, t = r.apply, i = r.call;
  return nt = typeof Reflect == "object" && Reflect.apply || (e ? i.bind(t) : function() {
    return i.apply(t, arguments);
  }), nt;
}
var at, pa;
function W() {
  if (pa) return at;
  pa = 1;
  var e = /* @__PURE__ */ Nr(), r = Function.prototype, t = r.call, i = e && r.bind.bind(t, t);
  return at = e ? i : function(n) {
    return function() {
      return t.apply(n, arguments);
    };
  }, at;
}
var ot, ma;
function Xe() {
  if (ma) return ot;
  ma = 1;
  var e = /* @__PURE__ */ W(), r = e({}.toString), t = e("".slice);
  return ot = function(i) {
    return t(r(i), 8, -1);
  }, ot;
}
var st, ga;
function gc() {
  if (ga) return st;
  ga = 1;
  var e = /* @__PURE__ */ Xe(), r = /* @__PURE__ */ W();
  return st = function(t) {
    if (e(t) === "Function") return r(t);
  }, st;
}
var ut, wa;
function H() {
  if (wa) return ut;
  wa = 1;
  var e = typeof document == "object" && document.all;
  return ut = typeof e > "u" && e !== void 0 ? function(r) {
    return typeof r == "function" || r === e;
  } : function(r) {
    return typeof r == "function";
  }, ut;
}
var ct = {}, lt, Sa;
function de() {
  if (Sa) return lt;
  Sa = 1;
  var e = /* @__PURE__ */ Y();
  return lt = !e(function() {
    return Object.defineProperty({}, 1, { get: function() {
      return 7;
    } })[1] !== 7;
  }), lt;
}
var ft, _a;
function Be() {
  if (_a) return ft;
  _a = 1;
  var e = /* @__PURE__ */ Nr(), r = Function.prototype.call;
  return ft = e ? r.bind(r) : function() {
    return r.apply(r, arguments);
  }, ft;
}
var vt = {}, Oa;
function wc() {
  if (Oa) return vt;
  Oa = 1;
  var e = {}.propertyIsEnumerable, r = Object.getOwnPropertyDescriptor, t = r && !e.call({ 1: 2 }, 1);
  return vt.f = t ? function(n) {
    var o = r(this, n);
    return !!o && o.enumerable;
  } : e, vt;
}
var dt, Ta;
function mr() {
  return Ta || (Ta = 1, dt = function(e, r) {
    return {
      enumerable: !(e & 1),
      configurable: !(e & 2),
      writable: !(e & 4),
      value: r
    };
  }), dt;
}
var ht, Ea;
function Sc() {
  if (Ea) return ht;
  Ea = 1;
  var e = /* @__PURE__ */ W(), r = /* @__PURE__ */ Y(), t = /* @__PURE__ */ Xe(), i = Object, n = e("".split);
  return ht = r(function() {
    return !i("z").propertyIsEnumerable(0);
  }) ? function(o) {
    return t(o) === "String" ? n(o, "") : i(o);
  } : i, ht;
}
var bt, Ra;
function _c() {
  return Ra || (Ra = 1, bt = function(e) {
    return e == null;
  }), bt;
}
var yt, Ia;
function Mr() {
  if (Ia) return yt;
  Ia = 1;
  var e = /* @__PURE__ */ _c(), r = TypeError;
  return yt = function(t) {
    if (e(t)) throw new r("Can't call method on " + t);
    return t;
  }, yt;
}
var pt, qa;
function $e() {
  if (qa) return pt;
  qa = 1;
  var e = /* @__PURE__ */ Sc(), r = /* @__PURE__ */ Mr();
  return pt = function(t) {
    return e(r(t));
  }, pt;
}
var mt, Pa;
function ye() {
  if (Pa) return mt;
  Pa = 1;
  var e = /* @__PURE__ */ H();
  return mt = function(r) {
    return typeof r == "object" ? r !== null : e(r);
  }, mt;
}
var gt, xa;
function gr() {
  return xa || (xa = 1, gt = {}), gt;
}
var wt, Aa;
function Re() {
  if (Aa) return wt;
  Aa = 1;
  var e = /* @__PURE__ */ gr(), r = /* @__PURE__ */ re(), t = /* @__PURE__ */ H(), i = function(n) {
    return t(n) ? n : void 0;
  };
  return wt = function(n, o) {
    return arguments.length < 2 ? i(e[n]) || i(r[n]) : e[n] && e[n][o] || r[n] && r[n][o];
  }, wt;
}
var St, Ca;
function Oc() {
  if (Ca) return St;
  Ca = 1;
  var e = /* @__PURE__ */ W();
  return St = e({}.isPrototypeOf), St;
}
var _t, ja;
function rl() {
  if (ja) return _t;
  ja = 1;
  var e = /* @__PURE__ */ re(), r = e.navigator, t = r && r.userAgent;
  return _t = t ? String(t) : "", _t;
}
var Ot, Da;
function Un() {
  if (Da) return Ot;
  Da = 1;
  var e = /* @__PURE__ */ re(), r = /* @__PURE__ */ rl(), t = e.process, i = e.Deno, n = t && t.versions || i && i.version, o = n && n.v8, a, u;
  return o && (a = o.split("."), u = a[0] > 0 && a[0] < 4 ? 1 : +(a[0] + a[1])), !u && r && (a = r.match(/Edge\/(\d+)/), (!a || a[1] >= 74) && (a = r.match(/Chrome\/(\d+)/), a && (u = +a[1]))), Ot = u, Ot;
}
var Tt, ka;
function Je() {
  if (ka) return Tt;
  ka = 1;
  var e = /* @__PURE__ */ Un(), r = /* @__PURE__ */ Y(), t = /* @__PURE__ */ re(), i = t.String;
  return Tt = !!Object.getOwnPropertySymbols && !r(function() {
    var n = Symbol("symbol detection");
    return !i(n) || !(Object(n) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && e && e < 41;
  }), Tt;
}
var Et, Fa;
function Tc() {
  if (Fa) return Et;
  Fa = 1;
  var e = /* @__PURE__ */ Je();
  return Et = e && !Symbol.sham && typeof Symbol.iterator == "symbol", Et;
}
var Rt, Na;
function wr() {
  if (Na) return Rt;
  Na = 1;
  var e = /* @__PURE__ */ Re(), r = /* @__PURE__ */ H(), t = /* @__PURE__ */ Oc(), i = /* @__PURE__ */ Tc(), n = Object;
  return Rt = i ? function(o) {
    return typeof o == "symbol";
  } : function(o) {
    var a = e("Symbol");
    return r(a) && t(a.prototype, n(o));
  }, Rt;
}
var It, Ma;
function Ec() {
  if (Ma) return It;
  Ma = 1;
  var e = String;
  return It = function(r) {
    try {
      return e(r);
    } catch {
      return "Object";
    }
  }, It;
}
var qt, La;
function Kn() {
  if (La) return qt;
  La = 1;
  var e = /* @__PURE__ */ H(), r = /* @__PURE__ */ Ec(), t = TypeError;
  return qt = function(i) {
    if (e(i)) return i;
    throw new t(r(i) + " is not a function");
  }, qt;
}
var Pt, Ba;
function tl() {
  if (Ba) return Pt;
  Ba = 1;
  var e = /* @__PURE__ */ Kn(), r = /* @__PURE__ */ _c();
  return Pt = function(t, i) {
    var n = t[i];
    return r(n) ? void 0 : e(n);
  }, Pt;
}
var xt, $a;
function il() {
  if ($a) return xt;
  $a = 1;
  var e = /* @__PURE__ */ Be(), r = /* @__PURE__ */ H(), t = /* @__PURE__ */ ye(), i = TypeError;
  return xt = function(n, o) {
    var a, u;
    if (o === "string" && r(a = n.toString) && !t(u = e(a, n)) || r(a = n.valueOf) && !t(u = e(a, n)) || o !== "string" && r(a = n.toString) && !t(u = e(a, n))) return u;
    throw new i("Can't convert object to primitive value");
  }, xt;
}
var At = { exports: {} }, Ct, Ua;
function Sr() {
  return Ua || (Ua = 1, Ct = !0), Ct;
}
var jt, Ka;
function nl() {
  if (Ka) return jt;
  Ka = 1;
  var e = /* @__PURE__ */ re(), r = Object.defineProperty;
  return jt = function(t, i) {
    try {
      r(e, t, { value: i, configurable: !0, writable: !0 });
    } catch {
      e[t] = i;
    }
    return i;
  }, jt;
}
var Ga;
function Gn() {
  if (Ga) return At.exports;
  Ga = 1;
  var e = /* @__PURE__ */ Sr(), r = /* @__PURE__ */ re(), t = /* @__PURE__ */ nl(), i = "__core-js_shared__", n = At.exports = r[i] || t(i, {});
  return (n.versions || (n.versions = [])).push({
    version: "3.41.0",
    mode: e ? "pure" : "global",
    copyright: "© 2014-2025 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.41.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
  }), At.exports;
}
var Dt, Wa;
function Ze() {
  if (Wa) return Dt;
  Wa = 1;
  var e = /* @__PURE__ */ Gn();
  return Dt = function(r, t) {
    return e[r] || (e[r] = t || {});
  }, Dt;
}
var kt, Va;
function _r() {
  if (Va) return kt;
  Va = 1;
  var e = /* @__PURE__ */ Mr(), r = Object;
  return kt = function(t) {
    return r(e(t));
  }, kt;
}
var Ft, Ha;
function le() {
  if (Ha) return Ft;
  Ha = 1;
  var e = /* @__PURE__ */ W(), r = /* @__PURE__ */ _r(), t = e({}.hasOwnProperty);
  return Ft = Object.hasOwn || function(n, o) {
    return t(r(n), o);
  }, Ft;
}
var Nt, za;
function Wn() {
  if (za) return Nt;
  za = 1;
  var e = /* @__PURE__ */ W(), r = 0, t = Math.random(), i = e(1 .toString);
  return Nt = function(n) {
    return "Symbol(" + (n === void 0 ? "" : n) + ")_" + i(++r + t, 36);
  }, Nt;
}
var Mt, Ya;
function te() {
  if (Ya) return Mt;
  Ya = 1;
  var e = /* @__PURE__ */ re(), r = /* @__PURE__ */ Ze(), t = /* @__PURE__ */ le(), i = /* @__PURE__ */ Wn(), n = /* @__PURE__ */ Je(), o = /* @__PURE__ */ Tc(), a = e.Symbol, u = r("wks"), s = o ? a.for || a : a && a.withoutSetter || i;
  return Mt = function(c) {
    return t(u, c) || (u[c] = n && t(a, c) ? a[c] : s("Symbol." + c)), u[c];
  }, Mt;
}
var Lt, Qa;
function al() {
  if (Qa) return Lt;
  Qa = 1;
  var e = /* @__PURE__ */ Be(), r = /* @__PURE__ */ ye(), t = /* @__PURE__ */ wr(), i = /* @__PURE__ */ tl(), n = /* @__PURE__ */ il(), o = /* @__PURE__ */ te(), a = TypeError, u = o("toPrimitive");
  return Lt = function(s, c) {
    if (!r(s) || t(s)) return s;
    var f = i(s, u), v;
    if (f) {
      if (c === void 0 && (c = "default"), v = e(f, s, c), !r(v) || t(v)) return v;
      throw new a("Can't convert object to primitive value");
    }
    return c === void 0 && (c = "number"), n(s, c);
  }, Lt;
}
var Bt, Xa;
function Vn() {
  if (Xa) return Bt;
  Xa = 1;
  var e = /* @__PURE__ */ al(), r = /* @__PURE__ */ wr();
  return Bt = function(t) {
    var i = e(t, "string");
    return r(i) ? i : i + "";
  }, Bt;
}
var $t, Ja;
function Rc() {
  if (Ja) return $t;
  Ja = 1;
  var e = /* @__PURE__ */ re(), r = /* @__PURE__ */ ye(), t = e.document, i = r(t) && r(t.createElement);
  return $t = function(n) {
    return i ? t.createElement(n) : {};
  }, $t;
}
var Ut, Za;
function Ic() {
  if (Za) return Ut;
  Za = 1;
  var e = /* @__PURE__ */ de(), r = /* @__PURE__ */ Y(), t = /* @__PURE__ */ Rc();
  return Ut = !e && !r(function() {
    return Object.defineProperty(t("div"), "a", {
      get: function() {
        return 7;
      }
    }).a !== 7;
  }), Ut;
}
var eo;
function qc() {
  if (eo) return ct;
  eo = 1;
  var e = /* @__PURE__ */ de(), r = /* @__PURE__ */ Be(), t = /* @__PURE__ */ wc(), i = /* @__PURE__ */ mr(), n = /* @__PURE__ */ $e(), o = /* @__PURE__ */ Vn(), a = /* @__PURE__ */ le(), u = /* @__PURE__ */ Ic(), s = Object.getOwnPropertyDescriptor;
  return ct.f = e ? s : function(f, v) {
    if (f = n(f), v = o(v), u) try {
      return s(f, v);
    } catch {
    }
    if (a(f, v)) return i(!r(t.f, f, v), f[v]);
  }, ct;
}
var Kt, ro;
function ol() {
  if (ro) return Kt;
  ro = 1;
  var e = /* @__PURE__ */ Y(), r = /* @__PURE__ */ H(), t = /#|\.prototype\./, i = function(s, c) {
    var f = o[n(s)];
    return f === u ? !0 : f === a ? !1 : r(c) ? e(c) : !!c;
  }, n = i.normalize = function(s) {
    return String(s).replace(t, ".").toLowerCase();
  }, o = i.data = {}, a = i.NATIVE = "N", u = i.POLYFILL = "P";
  return Kt = i, Kt;
}
var Gt, to;
function Pc() {
  if (to) return Gt;
  to = 1;
  var e = /* @__PURE__ */ gc(), r = /* @__PURE__ */ Kn(), t = /* @__PURE__ */ Nr(), i = e(e.bind);
  return Gt = function(n, o) {
    return r(n), o === void 0 ? n : t ? i(n, o) : function() {
      return n.apply(o, arguments);
    };
  }, Gt;
}
var Wt = {}, Vt, io;
function xc() {
  if (io) return Vt;
  io = 1;
  var e = /* @__PURE__ */ de(), r = /* @__PURE__ */ Y();
  return Vt = e && r(function() {
    return Object.defineProperty(function() {
    }, "prototype", {
      value: 42,
      writable: !1
    }).prototype !== 42;
  }), Vt;
}
var Ht, no;
function Lr() {
  if (no) return Ht;
  no = 1;
  var e = /* @__PURE__ */ ye(), r = String, t = TypeError;
  return Ht = function(i) {
    if (e(i)) return i;
    throw new t(r(i) + " is not an object");
  }, Ht;
}
var ao;
function pe() {
  if (ao) return Wt;
  ao = 1;
  var e = /* @__PURE__ */ de(), r = /* @__PURE__ */ Ic(), t = /* @__PURE__ */ xc(), i = /* @__PURE__ */ Lr(), n = /* @__PURE__ */ Vn(), o = TypeError, a = Object.defineProperty, u = Object.getOwnPropertyDescriptor, s = "enumerable", c = "configurable", f = "writable";
  return Wt.f = e ? t ? function(p, m, g) {
    if (i(p), m = n(m), i(g), typeof p == "function" && m === "prototype" && "value" in g && f in g && !g[f]) {
      var S = u(p, m);
      S && S[f] && (p[m] = g.value, g = {
        configurable: c in g ? g[c] : S[c],
        enumerable: s in g ? g[s] : S[s],
        writable: !1
      });
    }
    return a(p, m, g);
  } : a : function(p, m, g) {
    if (i(p), m = n(m), i(g), r) try {
      return a(p, m, g);
    } catch {
    }
    if ("get" in g || "set" in g) throw new o("Accessors not supported");
    return "value" in g && (p[m] = g.value), p;
  }, Wt;
}
var zt, oo;
function Or() {
  if (oo) return zt;
  oo = 1;
  var e = /* @__PURE__ */ de(), r = /* @__PURE__ */ pe(), t = /* @__PURE__ */ mr();
  return zt = e ? function(i, n, o) {
    return r.f(i, n, t(1, o));
  } : function(i, n, o) {
    return i[n] = o, i;
  }, zt;
}
var Yt, so;
function fe() {
  if (so) return Yt;
  so = 1;
  var e = /* @__PURE__ */ re(), r = /* @__PURE__ */ mc(), t = /* @__PURE__ */ gc(), i = /* @__PURE__ */ H(), n = qc().f, o = /* @__PURE__ */ ol(), a = /* @__PURE__ */ gr(), u = /* @__PURE__ */ Pc(), s = /* @__PURE__ */ Or(), c = /* @__PURE__ */ le(), f = function(v) {
    var p = function(m, g, S) {
      if (this instanceof p) {
        switch (arguments.length) {
          case 0:
            return new v();
          case 1:
            return new v(m);
          case 2:
            return new v(m, g);
        }
        return new v(m, g, S);
      }
      return r(v, this, arguments);
    };
    return p.prototype = v.prototype, p;
  };
  return Yt = function(v, p) {
    var m = v.target, g = v.global, S = v.stat, _ = v.proto, R = g ? e : S ? e[m] : e[m] && e[m].prototype, w = g ? a : a[m] || s(a, m, {})[m], O = w.prototype, E, C, B, k, I, q, $, j, K;
    for (k in p)
      E = o(g ? k : m + (S ? "." : "#") + k, v.forced), C = !E && R && c(R, k), q = w[k], C && (v.dontCallGetSet ? (K = n(R, k), $ = K && K.value) : $ = R[k]), I = C && $ ? $ : p[k], !(!E && !_ && typeof q == typeof I) && (v.bind && C ? j = u(I, e) : v.wrap && C ? j = f(I) : _ && i(I) ? j = t(I) : j = I, (v.sham || I && I.sham || q && q.sham) && s(j, "sham", !0), s(w, k, j), _ && (B = m + "Prototype", c(a, B) || s(a, B, {}), s(a[B], k, I), v.real && O && (E || !O[k]) && s(O, k, I)));
  }, Yt;
}
var uo;
function sl() {
  if (uo) return va;
  uo = 1;
  var e = /* @__PURE__ */ fe(), r = /* @__PURE__ */ de(), t = pe().f;
  return e({ target: "Object", stat: !0, forced: Object.defineProperty !== t, sham: !r }, {
    defineProperty: t
  }), va;
}
var co;
function ul() {
  if (co) return rt.exports;
  co = 1, sl();
  var e = /* @__PURE__ */ gr(), r = e.Object, t = rt.exports = function(n, o, a) {
    return r.defineProperty(n, o, a);
  };
  return r.defineProperty.sham && (t.sham = !0), rt.exports;
}
var Qt, lo;
function cl() {
  if (lo) return Qt;
  lo = 1;
  var e = /* @__PURE__ */ ul();
  return Qt = e, Qt;
}
var Xt, fo;
function ll() {
  if (fo) return Xt;
  fo = 1;
  var e = /* @__PURE__ */ cl();
  return Xt = e, Xt;
}
var Jt, vo;
function fl() {
  if (vo) return Jt;
  vo = 1;
  var e = /* @__PURE__ */ ll();
  return Jt = e, Jt;
}
var Zt, ho;
function vl() {
  return ho || (ho = 1, Zt = /* @__PURE__ */ fl()), Zt;
}
var dl = /* @__PURE__ */ vl();
const hl = /* @__PURE__ */ Fr(dl);
var bo = {}, ei, yo;
function Hn() {
  if (yo) return ei;
  yo = 1;
  var e = /* @__PURE__ */ Xe();
  return ei = Array.isArray || function(t) {
    return e(t) === "Array";
  }, ei;
}
var ri, po;
function bl() {
  if (po) return ri;
  po = 1;
  var e = Math.ceil, r = Math.floor;
  return ri = Math.trunc || function(i) {
    var n = +i;
    return (n > 0 ? r : e)(n);
  }, ri;
}
var ti, mo;
function zn() {
  if (mo) return ti;
  mo = 1;
  var e = /* @__PURE__ */ bl();
  return ti = function(r) {
    var t = +r;
    return t !== t || t === 0 ? 0 : e(t);
  }, ti;
}
var ii, go;
function yl() {
  if (go) return ii;
  go = 1;
  var e = /* @__PURE__ */ zn(), r = Math.min;
  return ii = function(t) {
    var i = e(t);
    return i > 0 ? r(i, 9007199254740991) : 0;
  }, ii;
}
var ni, wo;
function Yn() {
  if (wo) return ni;
  wo = 1;
  var e = /* @__PURE__ */ yl();
  return ni = function(r) {
    return e(r.length);
  }, ni;
}
var ai, So;
function pl() {
  if (So) return ai;
  So = 1;
  var e = TypeError, r = 9007199254740991;
  return ai = function(t) {
    if (t > r) throw e("Maximum allowed index exceeded");
    return t;
  }, ai;
}
var oi, _o;
function ml() {
  if (_o) return oi;
  _o = 1;
  var e = /* @__PURE__ */ de(), r = /* @__PURE__ */ pe(), t = /* @__PURE__ */ mr();
  return oi = function(i, n, o) {
    e ? r.f(i, n, t(0, o)) : i[n] = o;
  }, oi;
}
var si, Oo;
function Qn() {
  if (Oo) return si;
  Oo = 1;
  var e = /* @__PURE__ */ te(), r = e("toStringTag"), t = {};
  return t[r] = "z", si = String(t) === "[object z]", si;
}
var ui, To;
function Xn() {
  if (To) return ui;
  To = 1;
  var e = /* @__PURE__ */ Qn(), r = /* @__PURE__ */ H(), t = /* @__PURE__ */ Xe(), i = /* @__PURE__ */ te(), n = i("toStringTag"), o = Object, a = t(/* @__PURE__ */ function() {
    return arguments;
  }()) === "Arguments", u = function(s, c) {
    try {
      return s[c];
    } catch {
    }
  };
  return ui = e ? t : function(s) {
    var c, f, v;
    return s === void 0 ? "Undefined" : s === null ? "Null" : typeof (f = u(c = o(s), n)) == "string" ? f : a ? t(c) : (v = t(c)) === "Object" && r(c.callee) ? "Arguments" : v;
  }, ui;
}
var ci, Eo;
function gl() {
  if (Eo) return ci;
  Eo = 1;
  var e = /* @__PURE__ */ W(), r = /* @__PURE__ */ H(), t = /* @__PURE__ */ Gn(), i = e(Function.toString);
  return r(t.inspectSource) || (t.inspectSource = function(n) {
    return i(n);
  }), ci = t.inspectSource, ci;
}
var li, Ro;
function wl() {
  if (Ro) return li;
  Ro = 1;
  var e = /* @__PURE__ */ W(), r = /* @__PURE__ */ Y(), t = /* @__PURE__ */ H(), i = /* @__PURE__ */ Xn(), n = /* @__PURE__ */ Re(), o = /* @__PURE__ */ gl(), a = function() {
  }, u = n("Reflect", "construct"), s = /^\s*(?:class|function)\b/, c = e(s.exec), f = !s.test(a), v = function(g) {
    if (!t(g)) return !1;
    try {
      return u(a, [], g), !0;
    } catch {
      return !1;
    }
  }, p = function(g) {
    if (!t(g)) return !1;
    switch (i(g)) {
      case "AsyncFunction":
      case "GeneratorFunction":
      case "AsyncGeneratorFunction":
        return !1;
    }
    try {
      return f || !!c(s, o(g));
    } catch {
      return !0;
    }
  };
  return p.sham = !0, li = !u || r(function() {
    var m;
    return v(v.call) || !v(Object) || !v(function() {
      m = !0;
    }) || m;
  }) ? p : v, li;
}
var fi, Io;
function Sl() {
  if (Io) return fi;
  Io = 1;
  var e = /* @__PURE__ */ Hn(), r = /* @__PURE__ */ wl(), t = /* @__PURE__ */ ye(), i = /* @__PURE__ */ te(), n = i("species"), o = Array;
  return fi = function(a) {
    var u;
    return e(a) && (u = a.constructor, r(u) && (u === o || e(u.prototype)) ? u = void 0 : t(u) && (u = u[n], u === null && (u = void 0))), u === void 0 ? o : u;
  }, fi;
}
var vi, qo;
function Ac() {
  if (qo) return vi;
  qo = 1;
  var e = /* @__PURE__ */ Sl();
  return vi = function(r, t) {
    return new (e(r))(t === 0 ? 0 : t);
  }, vi;
}
var di, Po;
function _l() {
  if (Po) return di;
  Po = 1;
  var e = /* @__PURE__ */ Y(), r = /* @__PURE__ */ te(), t = /* @__PURE__ */ Un(), i = r("species");
  return di = function(n) {
    return t >= 51 || !e(function() {
      var o = [], a = o.constructor = {};
      return a[i] = function() {
        return { foo: 1 };
      }, o[n](Boolean).foo !== 1;
    });
  }, di;
}
var xo;
function Ol() {
  if (xo) return bo;
  xo = 1;
  var e = /* @__PURE__ */ fe(), r = /* @__PURE__ */ Y(), t = /* @__PURE__ */ Hn(), i = /* @__PURE__ */ ye(), n = /* @__PURE__ */ _r(), o = /* @__PURE__ */ Yn(), a = /* @__PURE__ */ pl(), u = /* @__PURE__ */ ml(), s = /* @__PURE__ */ Ac(), c = /* @__PURE__ */ _l(), f = /* @__PURE__ */ te(), v = /* @__PURE__ */ Un(), p = f("isConcatSpreadable"), m = v >= 51 || !r(function() {
    var _ = [];
    return _[p] = !1, _.concat()[0] !== _;
  }), g = function(_) {
    if (!i(_)) return !1;
    var R = _[p];
    return R !== void 0 ? !!R : t(_);
  }, S = !m || !c("concat");
  return e({ target: "Array", proto: !0, arity: 1, forced: S }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function(R) {
      var w = n(this), O = s(w, 0), E = 0, C, B, k, I, q;
      for (C = -1, k = arguments.length; C < k; C++)
        if (q = C === -1 ? w : arguments[C], g(q))
          for (I = o(q), a(E + I), B = 0; B < I; B++, E++) B in q && u(O, E, q[B]);
        else
          a(E + 1), u(O, E++, q);
      return O.length = E, O;
    }
  }), bo;
}
var Ao = {}, Co = {}, hi, jo;
function Tr() {
  if (jo) return hi;
  jo = 1;
  var e = /* @__PURE__ */ Xn(), r = String;
  return hi = function(t) {
    if (e(t) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return r(t);
  }, hi;
}
var bi = {}, yi, Do;
function Tl() {
  if (Do) return yi;
  Do = 1;
  var e = /* @__PURE__ */ zn(), r = Math.max, t = Math.min;
  return yi = function(i, n) {
    var o = e(i);
    return o < 0 ? r(o + n, 0) : t(o, n);
  }, yi;
}
var pi, ko;
function El() {
  if (ko) return pi;
  ko = 1;
  var e = /* @__PURE__ */ $e(), r = /* @__PURE__ */ Tl(), t = /* @__PURE__ */ Yn(), i = function(n) {
    return function(o, a, u) {
      var s = e(o), c = t(s);
      if (c === 0) return !n && -1;
      var f = r(u, c), v;
      if (n && a !== a) {
        for (; c > f; )
          if (v = s[f++], v !== v) return !0;
      } else for (; c > f; f++)
        if ((n || f in s) && s[f] === a) return n || f || 0;
      return !n && -1;
    };
  };
  return pi = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: i(!0),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: i(!1)
  }, pi;
}
var mi, Fo;
function Br() {
  return Fo || (Fo = 1, mi = {}), mi;
}
var gi, No;
function Cc() {
  if (No) return gi;
  No = 1;
  var e = /* @__PURE__ */ W(), r = /* @__PURE__ */ le(), t = /* @__PURE__ */ $e(), i = El().indexOf, n = /* @__PURE__ */ Br(), o = e([].push);
  return gi = function(a, u) {
    var s = t(a), c = 0, f = [], v;
    for (v in s) !r(n, v) && r(s, v) && o(f, v);
    for (; u.length > c; ) r(s, v = u[c++]) && (~i(f, v) || o(f, v));
    return f;
  }, gi;
}
var wi, Mo;
function Jn() {
  return Mo || (Mo = 1, wi = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
  ]), wi;
}
var Si, Lo;
function jc() {
  if (Lo) return Si;
  Lo = 1;
  var e = /* @__PURE__ */ Cc(), r = /* @__PURE__ */ Jn();
  return Si = Object.keys || function(i) {
    return e(i, r);
  }, Si;
}
var Bo;
function Dc() {
  if (Bo) return bi;
  Bo = 1;
  var e = /* @__PURE__ */ de(), r = /* @__PURE__ */ xc(), t = /* @__PURE__ */ pe(), i = /* @__PURE__ */ Lr(), n = /* @__PURE__ */ $e(), o = /* @__PURE__ */ jc();
  return bi.f = e && !r ? Object.defineProperties : function(u, s) {
    i(u);
    for (var c = n(s), f = o(s), v = f.length, p = 0, m; v > p; ) t.f(u, m = f[p++], c[m]);
    return u;
  }, bi;
}
var _i, $o;
function Rl() {
  if ($o) return _i;
  $o = 1;
  var e = /* @__PURE__ */ Re();
  return _i = e("document", "documentElement"), _i;
}
var Oi, Uo;
function $r() {
  if (Uo) return Oi;
  Uo = 1;
  var e = /* @__PURE__ */ Ze(), r = /* @__PURE__ */ Wn(), t = e("keys");
  return Oi = function(i) {
    return t[i] || (t[i] = r(i));
  }, Oi;
}
var Ti, Ko;
function Zn() {
  if (Ko) return Ti;
  Ko = 1;
  var e = /* @__PURE__ */ Lr(), r = /* @__PURE__ */ Dc(), t = /* @__PURE__ */ Jn(), i = /* @__PURE__ */ Br(), n = /* @__PURE__ */ Rl(), o = /* @__PURE__ */ Rc(), a = /* @__PURE__ */ $r(), u = ">", s = "<", c = "prototype", f = "script", v = a("IE_PROTO"), p = function() {
  }, m = function(w) {
    return s + f + u + w + s + "/" + f + u;
  }, g = function(w) {
    w.write(m("")), w.close();
    var O = w.parentWindow.Object;
    return w = null, O;
  }, S = function() {
    var w = o("iframe"), O = "java" + f + ":", E;
    return w.style.display = "none", n.appendChild(w), w.src = String(O), E = w.contentWindow.document, E.open(), E.write(m("document.F=Object")), E.close(), E.F;
  }, _, R = function() {
    try {
      _ = new ActiveXObject("htmlfile");
    } catch {
    }
    R = typeof document < "u" ? document.domain && _ ? g(_) : S() : g(_);
    for (var w = t.length; w--; ) delete R[c][t[w]];
    return R();
  };
  return i[v] = !0, Ti = Object.create || function(O, E) {
    var C;
    return O !== null ? (p[c] = e(O), C = new p(), p[c] = null, C[v] = O) : C = R(), E === void 0 ? C : r.f(C, E);
  }, Ti;
}
var Ei = {}, Go;
function kc() {
  if (Go) return Ei;
  Go = 1;
  var e = /* @__PURE__ */ Cc(), r = /* @__PURE__ */ Jn(), t = r.concat("length", "prototype");
  return Ei.f = Object.getOwnPropertyNames || function(n) {
    return e(n, t);
  }, Ei;
}
var Ri = {}, Ii, Wo;
function Fc() {
  if (Wo) return Ii;
  Wo = 1;
  var e = /* @__PURE__ */ W();
  return Ii = e([].slice), Ii;
}
var Vo;
function Il() {
  if (Vo) return Ri;
  Vo = 1;
  var e = /* @__PURE__ */ Xe(), r = /* @__PURE__ */ $e(), t = kc().f, i = /* @__PURE__ */ Fc(), n = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], o = function(a) {
    try {
      return t(a);
    } catch {
      return i(n);
    }
  };
  return Ri.f = function(u) {
    return n && e(u) === "Window" ? o(u) : t(r(u));
  }, Ri;
}
var qi = {}, Ho;
function Nc() {
  return Ho || (Ho = 1, qi.f = Object.getOwnPropertySymbols), qi;
}
var Pi, zo;
function Ur() {
  if (zo) return Pi;
  zo = 1;
  var e = /* @__PURE__ */ Or();
  return Pi = function(r, t, i, n) {
    return n && n.enumerable ? r[t] = i : e(r, t, i), r;
  }, Pi;
}
var xi, Yo;
function ql() {
  if (Yo) return xi;
  Yo = 1;
  var e = /* @__PURE__ */ pe();
  return xi = function(r, t, i) {
    return e.f(r, t, i);
  }, xi;
}
var Ai = {}, Qo;
function Kr() {
  if (Qo) return Ai;
  Qo = 1;
  var e = /* @__PURE__ */ te();
  return Ai.f = e, Ai;
}
var Ci, Xo;
function U() {
  if (Xo) return Ci;
  Xo = 1;
  var e = /* @__PURE__ */ gr(), r = /* @__PURE__ */ le(), t = /* @__PURE__ */ Kr(), i = pe().f;
  return Ci = function(n) {
    var o = e.Symbol || (e.Symbol = {});
    r(o, n) || i(o, n, {
      value: t.f(n)
    });
  }, Ci;
}
var ji, Jo;
function Mc() {
  if (Jo) return ji;
  Jo = 1;
  var e = /* @__PURE__ */ Be(), r = /* @__PURE__ */ Re(), t = /* @__PURE__ */ te(), i = /* @__PURE__ */ Ur();
  return ji = function() {
    var n = r("Symbol"), o = n && n.prototype, a = o && o.valueOf, u = t("toPrimitive");
    o && !o[u] && i(o, u, function(s) {
      return e(a, this);
    }, { arity: 1 });
  }, ji;
}
var Di, Zo;
function Pl() {
  if (Zo) return Di;
  Zo = 1;
  var e = /* @__PURE__ */ Qn(), r = /* @__PURE__ */ Xn();
  return Di = e ? {}.toString : function() {
    return "[object " + r(this) + "]";
  }, Di;
}
var ki, es;
function er() {
  if (es) return ki;
  es = 1;
  var e = /* @__PURE__ */ Qn(), r = pe().f, t = /* @__PURE__ */ Or(), i = /* @__PURE__ */ le(), n = /* @__PURE__ */ Pl(), o = /* @__PURE__ */ te(), a = o("toStringTag");
  return ki = function(u, s, c, f) {
    var v = c ? u : u && u.prototype;
    v && (i(v, a) || r(v, a, { configurable: !0, value: s }), f && !e && t(v, "toString", n));
  }, ki;
}
var Fi, rs;
function xl() {
  if (rs) return Fi;
  rs = 1;
  var e = /* @__PURE__ */ re(), r = /* @__PURE__ */ H(), t = e.WeakMap;
  return Fi = r(t) && /native code/.test(String(t)), Fi;
}
var Ni, ts;
function ea() {
  if (ts) return Ni;
  ts = 1;
  var e = /* @__PURE__ */ xl(), r = /* @__PURE__ */ re(), t = /* @__PURE__ */ ye(), i = /* @__PURE__ */ Or(), n = /* @__PURE__ */ le(), o = /* @__PURE__ */ Gn(), a = /* @__PURE__ */ $r(), u = /* @__PURE__ */ Br(), s = "Object already initialized", c = r.TypeError, f = r.WeakMap, v, p, m, g = function(w) {
    return m(w) ? p(w) : v(w, {});
  }, S = function(w) {
    return function(O) {
      var E;
      if (!t(O) || (E = p(O)).type !== w)
        throw new c("Incompatible receiver, " + w + " required");
      return E;
    };
  };
  if (e || o.state) {
    var _ = o.state || (o.state = new f());
    _.get = _.get, _.has = _.has, _.set = _.set, v = function(w, O) {
      if (_.has(w)) throw new c(s);
      return O.facade = w, _.set(w, O), O;
    }, p = function(w) {
      return _.get(w) || {};
    }, m = function(w) {
      return _.has(w);
    };
  } else {
    var R = a("state");
    u[R] = !0, v = function(w, O) {
      if (n(w, R)) throw new c(s);
      return O.facade = w, i(w, R, O), O;
    }, p = function(w) {
      return n(w, R) ? w[R] : {};
    }, m = function(w) {
      return n(w, R);
    };
  }
  return Ni = {
    set: v,
    get: p,
    has: m,
    enforce: g,
    getterFor: S
  }, Ni;
}
var Mi, is;
function Al() {
  if (is) return Mi;
  is = 1;
  var e = /* @__PURE__ */ Pc(), r = /* @__PURE__ */ W(), t = /* @__PURE__ */ Sc(), i = /* @__PURE__ */ _r(), n = /* @__PURE__ */ Yn(), o = /* @__PURE__ */ Ac(), a = r([].push), u = function(s) {
    var c = s === 1, f = s === 2, v = s === 3, p = s === 4, m = s === 6, g = s === 7, S = s === 5 || m;
    return function(_, R, w, O) {
      for (var E = i(_), C = t(E), B = n(C), k = e(R, w), I = 0, q = O || o, $ = c ? q(_, B) : f || g ? q(_, 0) : void 0, j, K; B > I; I++) if ((S || I in C) && (j = C[I], K = k(j, I, E), s))
        if (c) $[I] = K;
        else if (K) switch (s) {
          case 3:
            return !0;
          // some
          case 5:
            return j;
          // find
          case 6:
            return I;
          // findIndex
          case 2:
            a($, j);
        }
        else switch (s) {
          case 4:
            return !1;
          // every
          case 7:
            a($, j);
        }
      return m ? -1 : v || p ? p : $;
    };
  };
  return Mi = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: u(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: u(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: u(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: u(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: u(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: u(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: u(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: u(7)
  }, Mi;
}
var ns;
function Cl() {
  if (ns) return Co;
  ns = 1;
  var e = /* @__PURE__ */ fe(), r = /* @__PURE__ */ re(), t = /* @__PURE__ */ Be(), i = /* @__PURE__ */ W(), n = /* @__PURE__ */ Sr(), o = /* @__PURE__ */ de(), a = /* @__PURE__ */ Je(), u = /* @__PURE__ */ Y(), s = /* @__PURE__ */ le(), c = /* @__PURE__ */ Oc(), f = /* @__PURE__ */ Lr(), v = /* @__PURE__ */ $e(), p = /* @__PURE__ */ Vn(), m = /* @__PURE__ */ Tr(), g = /* @__PURE__ */ mr(), S = /* @__PURE__ */ Zn(), _ = /* @__PURE__ */ jc(), R = /* @__PURE__ */ kc(), w = /* @__PURE__ */ Il(), O = /* @__PURE__ */ Nc(), E = /* @__PURE__ */ qc(), C = /* @__PURE__ */ pe(), B = /* @__PURE__ */ Dc(), k = /* @__PURE__ */ wc(), I = /* @__PURE__ */ Ur(), q = /* @__PURE__ */ ql(), $ = /* @__PURE__ */ Ze(), j = /* @__PURE__ */ $r(), K = /* @__PURE__ */ Br(), ie = /* @__PURE__ */ Wn(), V = /* @__PURE__ */ te(), Ue = /* @__PURE__ */ Kr(), Ce = /* @__PURE__ */ U(), z = /* @__PURE__ */ Mc(), ae = /* @__PURE__ */ er(), oe = /* @__PURE__ */ ea(), me = Al().forEach, N = j("hidden"), se = "Symbol", ue = "prototype", ne = oe.set, je = oe.getterFor(se), Q = Object[ue], ge = r.Symbol, De = ge && ge[ue], Hr = r.RangeError, zr = r.TypeError, tr = r.QObject, Er = E.f, we = C.f, Rr = w.f, Yr = k.f, Ir = i([].push), Se = $("symbols"), ir = $("op-symbols"), Zc = $("wks"), Qr = !tr || !tr[ue] || !tr[ue].findChild, aa = function(M, P, x) {
    var A = Er(Q, P);
    A && delete Q[P], we(M, P, x), A && M !== Q && we(Q, P, A);
  }, Xr = o && u(function() {
    return S(we({}, "a", {
      get: function() {
        return we(this, "a", { value: 7 }).a;
      }
    })).a !== 7;
  }) ? aa : we, Jr = function(M, P) {
    var x = Se[M] = S(De);
    return ne(x, {
      type: se,
      tag: M,
      description: P
    }), o || (x.description = P), x;
  }, qr = function(P, x, A) {
    P === Q && qr(ir, x, A), f(P);
    var L = p(x);
    return f(A), s(Se, L) ? (A.enumerable ? (s(P, N) && P[N][L] && (P[N][L] = !1), A = S(A, { enumerable: g(0, !1) })) : (s(P, N) || we(P, N, g(1, S(null))), P[N][L] = !0), Xr(P, L, A)) : we(P, L, A);
  }, Zr = function(P, x) {
    f(P);
    var A = v(x), L = _(A).concat(ua(A));
    return me(L, function(X) {
      (!o || t(et, A, X)) && qr(P, X, A[X]);
    }), P;
  }, el = function(P, x) {
    return x === void 0 ? S(P) : Zr(S(P), x);
  }, et = function(P) {
    var x = p(P), A = t(Yr, this, x);
    return this === Q && s(Se, x) && !s(ir, x) ? !1 : A || !s(this, x) || !s(Se, x) || s(this, N) && this[N][x] ? A : !0;
  }, oa = function(P, x) {
    var A = v(P), L = p(x);
    if (!(A === Q && s(Se, L) && !s(ir, L))) {
      var X = Er(A, L);
      return X && s(Se, L) && !(s(A, N) && A[N][L]) && (X.enumerable = !0), X;
    }
  }, sa = function(P) {
    var x = Rr(v(P)), A = [];
    return me(x, function(L) {
      !s(Se, L) && !s(K, L) && Ir(A, L);
    }), A;
  }, ua = function(M) {
    var P = M === Q, x = Rr(P ? ir : v(M)), A = [];
    return me(x, function(L) {
      s(Se, L) && (!P || s(Q, L)) && Ir(A, Se[L]);
    }), A;
  };
  return a || (ge = function() {
    if (c(De, this)) throw new zr("Symbol is not a constructor");
    var P = !arguments.length || arguments[0] === void 0 ? void 0 : m(arguments[0]), x = ie(P), A = function(L) {
      var X = this === void 0 ? r : this;
      X === Q && t(A, ir, L), s(X, N) && s(X[N], x) && (X[N][x] = !1);
      var ca = g(1, L);
      try {
        Xr(X, x, ca);
      } catch (la) {
        if (!(la instanceof Hr)) throw la;
        aa(X, x, ca);
      }
    };
    return o && Qr && Xr(Q, x, { configurable: !0, set: A }), Jr(x, P);
  }, De = ge[ue], I(De, "toString", function() {
    return je(this).tag;
  }), I(ge, "withoutSetter", function(M) {
    return Jr(ie(M), M);
  }), k.f = et, C.f = qr, B.f = Zr, E.f = oa, R.f = w.f = sa, O.f = ua, Ue.f = function(M) {
    return Jr(V(M), M);
  }, o && (q(De, "description", {
    configurable: !0,
    get: function() {
      return je(this).description;
    }
  }), n || I(Q, "propertyIsEnumerable", et, { unsafe: !0 }))), e({ global: !0, constructor: !0, wrap: !0, forced: !a, sham: !a }, {
    Symbol: ge
  }), me(_(Zc), function(M) {
    Ce(M);
  }), e({ target: se, stat: !0, forced: !a }, {
    useSetter: function() {
      Qr = !0;
    },
    useSimple: function() {
      Qr = !1;
    }
  }), e({ target: "Object", stat: !0, forced: !a, sham: !o }, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: el,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: qr,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: Zr,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: oa
  }), e({ target: "Object", stat: !0, forced: !a }, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: sa
  }), z(), ae(ge, se), K[N] = !0, Co;
}
var as = {}, Li, os;
function Lc() {
  if (os) return Li;
  os = 1;
  var e = /* @__PURE__ */ Je();
  return Li = e && !!Symbol.for && !!Symbol.keyFor, Li;
}
var ss;
function jl() {
  if (ss) return as;
  ss = 1;
  var e = /* @__PURE__ */ fe(), r = /* @__PURE__ */ Re(), t = /* @__PURE__ */ le(), i = /* @__PURE__ */ Tr(), n = /* @__PURE__ */ Ze(), o = /* @__PURE__ */ Lc(), a = n("string-to-symbol-registry"), u = n("symbol-to-string-registry");
  return e({ target: "Symbol", stat: !0, forced: !o }, {
    for: function(s) {
      var c = i(s);
      if (t(a, c)) return a[c];
      var f = r("Symbol")(c);
      return a[c] = f, u[f] = c, f;
    }
  }), as;
}
var us = {}, cs;
function Dl() {
  if (cs) return us;
  cs = 1;
  var e = /* @__PURE__ */ fe(), r = /* @__PURE__ */ le(), t = /* @__PURE__ */ wr(), i = /* @__PURE__ */ Ec(), n = /* @__PURE__ */ Ze(), o = /* @__PURE__ */ Lc(), a = n("symbol-to-string-registry");
  return e({ target: "Symbol", stat: !0, forced: !o }, {
    keyFor: function(s) {
      if (!t(s)) throw new TypeError(i(s) + " is not a symbol");
      if (r(a, s)) return a[s];
    }
  }), us;
}
var ls = {}, Bi, fs;
function kl() {
  if (fs) return Bi;
  fs = 1;
  var e = /* @__PURE__ */ W(), r = /* @__PURE__ */ Hn(), t = /* @__PURE__ */ H(), i = /* @__PURE__ */ Xe(), n = /* @__PURE__ */ Tr(), o = e([].push);
  return Bi = function(a) {
    if (t(a)) return a;
    if (r(a)) {
      for (var u = a.length, s = [], c = 0; c < u; c++) {
        var f = a[c];
        typeof f == "string" ? o(s, f) : (typeof f == "number" || i(f) === "Number" || i(f) === "String") && o(s, n(f));
      }
      var v = s.length, p = !0;
      return function(m, g) {
        if (p)
          return p = !1, g;
        if (r(this)) return g;
        for (var S = 0; S < v; S++) if (s[S] === m) return g;
      };
    }
  }, Bi;
}
var vs;
function Fl() {
  if (vs) return ls;
  vs = 1;
  var e = /* @__PURE__ */ fe(), r = /* @__PURE__ */ Re(), t = /* @__PURE__ */ mc(), i = /* @__PURE__ */ Be(), n = /* @__PURE__ */ W(), o = /* @__PURE__ */ Y(), a = /* @__PURE__ */ H(), u = /* @__PURE__ */ wr(), s = /* @__PURE__ */ Fc(), c = /* @__PURE__ */ kl(), f = /* @__PURE__ */ Je(), v = String, p = r("JSON", "stringify"), m = n(/./.exec), g = n("".charAt), S = n("".charCodeAt), _ = n("".replace), R = n(1 .toString), w = /[\uD800-\uDFFF]/g, O = /^[\uD800-\uDBFF]$/, E = /^[\uDC00-\uDFFF]$/, C = !f || o(function() {
    var q = r("Symbol")("stringify detection");
    return p([q]) !== "[null]" || p({ a: q }) !== "{}" || p(Object(q)) !== "{}";
  }), B = o(function() {
    return p("\uDF06\uD834") !== '"\\udf06\\ud834"' || p("\uDEAD") !== '"\\udead"';
  }), k = function(q, $) {
    var j = s(arguments), K = c($);
    if (!(!a(K) && (q === void 0 || u(q))))
      return j[1] = function(ie, V) {
        if (a(K) && (V = i(K, this, v(ie), V)), !u(V)) return V;
      }, t(p, null, j);
  }, I = function(q, $, j) {
    var K = g(j, $ - 1), ie = g(j, $ + 1);
    return m(O, q) && !m(E, ie) || m(E, q) && !m(O, K) ? "\\u" + R(S(q, 0), 16) : q;
  };
  return p && e({ target: "JSON", stat: !0, arity: 3, forced: C || B }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function($, j, K) {
      var ie = s(arguments), V = t(C ? k : p, null, ie);
      return B && typeof V == "string" ? _(V, w, I) : V;
    }
  }), ls;
}
var ds = {}, hs;
function Nl() {
  if (hs) return ds;
  hs = 1;
  var e = /* @__PURE__ */ fe(), r = /* @__PURE__ */ Je(), t = /* @__PURE__ */ Y(), i = /* @__PURE__ */ Nc(), n = /* @__PURE__ */ _r(), o = !r || t(function() {
    i.f(1);
  });
  return e({ target: "Object", stat: !0, forced: o }, {
    getOwnPropertySymbols: function(u) {
      var s = i.f;
      return s ? s(n(u)) : [];
    }
  }), ds;
}
var bs;
function Ml() {
  return bs || (bs = 1, Cl(), jl(), Dl(), Fl(), Nl()), Ao;
}
var ys = {}, ps;
function Ll() {
  if (ps) return ys;
  ps = 1;
  var e = /* @__PURE__ */ U();
  return e("asyncIterator"), ys;
}
var ms = {}, gs;
function Bl() {
  if (gs) return ms;
  gs = 1;
  var e = /* @__PURE__ */ U();
  return e("hasInstance"), ms;
}
var ws = {}, Ss;
function $l() {
  if (Ss) return ws;
  Ss = 1;
  var e = /* @__PURE__ */ U();
  return e("isConcatSpreadable"), ws;
}
var _s = {}, Os;
function Bc() {
  if (Os) return _s;
  Os = 1;
  var e = /* @__PURE__ */ U();
  return e("iterator"), _s;
}
var Ts = {}, Es;
function Ul() {
  if (Es) return Ts;
  Es = 1;
  var e = /* @__PURE__ */ U();
  return e("match"), Ts;
}
var Rs = {}, Is;
function Kl() {
  if (Is) return Rs;
  Is = 1;
  var e = /* @__PURE__ */ U();
  return e("matchAll"), Rs;
}
var qs = {}, Ps;
function Gl() {
  if (Ps) return qs;
  Ps = 1;
  var e = /* @__PURE__ */ U();
  return e("replace"), qs;
}
var xs = {}, As;
function Wl() {
  if (As) return xs;
  As = 1;
  var e = /* @__PURE__ */ U();
  return e("search"), xs;
}
var Cs = {}, js;
function Vl() {
  if (js) return Cs;
  js = 1;
  var e = /* @__PURE__ */ U();
  return e("species"), Cs;
}
var Ds = {}, ks;
function Hl() {
  if (ks) return Ds;
  ks = 1;
  var e = /* @__PURE__ */ U();
  return e("split"), Ds;
}
var Fs = {}, Ns;
function $c() {
  if (Ns) return Fs;
  Ns = 1;
  var e = /* @__PURE__ */ U(), r = /* @__PURE__ */ Mc();
  return e("toPrimitive"), r(), Fs;
}
var Ms = {}, Ls;
function zl() {
  if (Ls) return Ms;
  Ls = 1;
  var e = /* @__PURE__ */ Re(), r = /* @__PURE__ */ U(), t = /* @__PURE__ */ er();
  return r("toStringTag"), t(e("Symbol"), "Symbol"), Ms;
}
var Bs = {}, $s;
function Yl() {
  if ($s) return Bs;
  $s = 1;
  var e = /* @__PURE__ */ U();
  return e("unscopables"), Bs;
}
var Us = {}, Ks;
function Ql() {
  if (Ks) return Us;
  Ks = 1;
  var e = /* @__PURE__ */ re(), r = /* @__PURE__ */ er();
  return r(e.JSON, "JSON", !0), Us;
}
var $i, Gs;
function Xl() {
  if (Gs) return $i;
  Gs = 1, Ol(), Ml(), Ll(), Bl(), $l(), Bc(), Ul(), Kl(), Gl(), Wl(), Vl(), Hl(), $c(), zl(), Yl(), Ql();
  var e = /* @__PURE__ */ gr();
  return $i = e.Symbol, $i;
}
var Ws = {}, Ui, Vs;
function Jl() {
  return Vs || (Vs = 1, Ui = function() {
  }), Ui;
}
var Ki, Hs;
function Gr() {
  return Hs || (Hs = 1, Ki = {}), Ki;
}
var Gi, zs;
function Zl() {
  if (zs) return Gi;
  zs = 1;
  var e = /* @__PURE__ */ de(), r = /* @__PURE__ */ le(), t = Function.prototype, i = e && Object.getOwnPropertyDescriptor, n = r(t, "name"), o = n && (function() {
  }).name === "something", a = n && (!e || e && i(t, "name").configurable);
  return Gi = {
    EXISTS: n,
    PROPER: o,
    CONFIGURABLE: a
  }, Gi;
}
var Wi, Ys;
function ef() {
  if (Ys) return Wi;
  Ys = 1;
  var e = /* @__PURE__ */ Y();
  return Wi = !e(function() {
    function r() {
    }
    return r.prototype.constructor = null, Object.getPrototypeOf(new r()) !== r.prototype;
  }), Wi;
}
var Vi, Qs;
function Uc() {
  if (Qs) return Vi;
  Qs = 1;
  var e = /* @__PURE__ */ le(), r = /* @__PURE__ */ H(), t = /* @__PURE__ */ _r(), i = /* @__PURE__ */ $r(), n = /* @__PURE__ */ ef(), o = i("IE_PROTO"), a = Object, u = a.prototype;
  return Vi = n ? a.getPrototypeOf : function(s) {
    var c = t(s);
    if (e(c, o)) return c[o];
    var f = c.constructor;
    return r(f) && c instanceof f ? f.prototype : c instanceof a ? u : null;
  }, Vi;
}
var Hi, Xs;
function Kc() {
  if (Xs) return Hi;
  Xs = 1;
  var e = /* @__PURE__ */ Y(), r = /* @__PURE__ */ H(), t = /* @__PURE__ */ ye(), i = /* @__PURE__ */ Zn(), n = /* @__PURE__ */ Uc(), o = /* @__PURE__ */ Ur(), a = /* @__PURE__ */ te(), u = /* @__PURE__ */ Sr(), s = a("iterator"), c = !1, f, v, p;
  [].keys && (p = [].keys(), "next" in p ? (v = n(n(p)), v !== Object.prototype && (f = v)) : c = !0);
  var m = !t(f) || e(function() {
    var g = {};
    return f[s].call(g) !== g;
  });
  return m ? f = {} : u && (f = i(f)), r(f[s]) || o(f, s, function() {
    return this;
  }), Hi = {
    IteratorPrototype: f,
    BUGGY_SAFARI_ITERATORS: c
  }, Hi;
}
var zi, Js;
function rf() {
  if (Js) return zi;
  Js = 1;
  var e = Kc().IteratorPrototype, r = /* @__PURE__ */ Zn(), t = /* @__PURE__ */ mr(), i = /* @__PURE__ */ er(), n = /* @__PURE__ */ Gr(), o = function() {
    return this;
  };
  return zi = function(a, u, s, c) {
    var f = u + " Iterator";
    return a.prototype = r(e, { next: t(+!c, s) }), i(a, f, !1, !0), n[f] = o, a;
  }, zi;
}
var Yi, Zs;
function tf() {
  if (Zs) return Yi;
  Zs = 1;
  var e = /* @__PURE__ */ W(), r = /* @__PURE__ */ Kn();
  return Yi = function(t, i, n) {
    try {
      return e(r(Object.getOwnPropertyDescriptor(t, i)[n]));
    } catch {
    }
  }, Yi;
}
var Qi, eu;
function nf() {
  if (eu) return Qi;
  eu = 1;
  var e = /* @__PURE__ */ ye();
  return Qi = function(r) {
    return e(r) || r === null;
  }, Qi;
}
var Xi, ru;
function af() {
  if (ru) return Xi;
  ru = 1;
  var e = /* @__PURE__ */ nf(), r = String, t = TypeError;
  return Xi = function(i) {
    if (e(i)) return i;
    throw new t("Can't set " + r(i) + " as a prototype");
  }, Xi;
}
var Ji, tu;
function of() {
  if (tu) return Ji;
  tu = 1;
  var e = /* @__PURE__ */ tf(), r = /* @__PURE__ */ ye(), t = /* @__PURE__ */ Mr(), i = /* @__PURE__ */ af();
  return Ji = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var n = !1, o = {}, a;
    try {
      a = e(Object.prototype, "__proto__", "set"), a(o, []), n = o instanceof Array;
    } catch {
    }
    return function(s, c) {
      return t(s), i(c), r(s) && (n ? a(s, c) : s.__proto__ = c), s;
    };
  }() : void 0), Ji;
}
var Zi, iu;
function Gc() {
  if (iu) return Zi;
  iu = 1;
  var e = /* @__PURE__ */ fe(), r = /* @__PURE__ */ Be(), t = /* @__PURE__ */ Sr(), i = /* @__PURE__ */ Zl(), n = /* @__PURE__ */ H(), o = /* @__PURE__ */ rf(), a = /* @__PURE__ */ Uc(), u = /* @__PURE__ */ of(), s = /* @__PURE__ */ er(), c = /* @__PURE__ */ Or(), f = /* @__PURE__ */ Ur(), v = /* @__PURE__ */ te(), p = /* @__PURE__ */ Gr(), m = /* @__PURE__ */ Kc(), g = i.PROPER, S = i.CONFIGURABLE, _ = m.IteratorPrototype, R = m.BUGGY_SAFARI_ITERATORS, w = v("iterator"), O = "keys", E = "values", C = "entries", B = function() {
    return this;
  };
  return Zi = function(k, I, q, $, j, K, ie) {
    o(q, I, $);
    var V = function(ne) {
      if (ne === j && oe) return oe;
      if (!R && ne && ne in z) return z[ne];
      switch (ne) {
        case O:
          return function() {
            return new q(this, ne);
          };
        case E:
          return function() {
            return new q(this, ne);
          };
        case C:
          return function() {
            return new q(this, ne);
          };
      }
      return function() {
        return new q(this);
      };
    }, Ue = I + " Iterator", Ce = !1, z = k.prototype, ae = z[w] || z["@@iterator"] || j && z[j], oe = !R && ae || V(j), me = I === "Array" && z.entries || ae, N, se, ue;
    if (me && (N = a(me.call(new k())), N !== Object.prototype && N.next && (!t && a(N) !== _ && (u ? u(N, _) : n(N[w]) || f(N, w, B)), s(N, Ue, !0, !0), t && (p[Ue] = B))), g && j === E && ae && ae.name !== E && (!t && S ? c(z, "name", E) : (Ce = !0, oe = function() {
      return r(ae, this);
    })), j)
      if (se = {
        values: V(E),
        keys: K ? oe : V(O),
        entries: V(C)
      }, ie) for (ue in se)
        (R || Ce || !(ue in z)) && f(z, ue, se[ue]);
      else e({ target: I, proto: !0, forced: R || Ce }, se);
    return (!t || ie) && z[w] !== oe && f(z, w, oe, { name: j }), p[I] = oe, se;
  }, Zi;
}
var en, nu;
function Wc() {
  return nu || (nu = 1, en = function(e, r) {
    return { value: e, done: r };
  }), en;
}
var rn, au;
function Vc() {
  if (au) return rn;
  au = 1;
  var e = /* @__PURE__ */ $e(), r = /* @__PURE__ */ Jl(), t = /* @__PURE__ */ Gr(), i = /* @__PURE__ */ ea(), n = pe().f, o = /* @__PURE__ */ Gc(), a = /* @__PURE__ */ Wc(), u = /* @__PURE__ */ Sr(), s = /* @__PURE__ */ de(), c = "Array Iterator", f = i.set, v = i.getterFor(c);
  rn = o(Array, "Array", function(m, g) {
    f(this, {
      type: c,
      target: e(m),
      // target
      index: 0,
      // next index
      kind: g
      // kind
    });
  }, function() {
    var m = v(this), g = m.target, S = m.index++;
    if (!g || S >= g.length)
      return m.target = null, a(void 0, !0);
    switch (m.kind) {
      case "keys":
        return a(S, !1);
      case "values":
        return a(g[S], !1);
    }
    return a([S, g[S]], !1);
  }, "values");
  var p = t.Arguments = t.Array;
  if (r("keys"), r("values"), r("entries"), !u && s && p.name !== "values") try {
    n(p, "name", { value: "values" });
  } catch {
  }
  return rn;
}
var tn, ou;
function sf() {
  return ou || (ou = 1, tn = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  }), tn;
}
var su;
function Hc() {
  if (su) return Ws;
  su = 1, Vc();
  var e = /* @__PURE__ */ sf(), r = /* @__PURE__ */ re(), t = /* @__PURE__ */ er(), i = /* @__PURE__ */ Gr();
  for (var n in e)
    t(r[n], n), i[n] = i.Array;
  return Ws;
}
var nn, uu;
function uf() {
  if (uu) return nn;
  uu = 1;
  var e = /* @__PURE__ */ Xl();
  return Hc(), nn = e, nn;
}
var cu = {}, lu;
function cf() {
  if (lu) return cu;
  lu = 1;
  var e = /* @__PURE__ */ te(), r = pe().f, t = e("metadata"), i = Function.prototype;
  return i[t] === void 0 && r(i, t, {
    value: null
  }), cu;
}
var fu = {}, vu;
function lf() {
  if (vu) return fu;
  vu = 1;
  var e = /* @__PURE__ */ U();
  return e("asyncDispose"), fu;
}
var du = {}, hu;
function ff() {
  if (hu) return du;
  hu = 1;
  var e = /* @__PURE__ */ U();
  return e("dispose"), du;
}
var bu = {}, yu;
function vf() {
  if (yu) return bu;
  yu = 1;
  var e = /* @__PURE__ */ U();
  return e("metadata"), bu;
}
var an, pu;
function df() {
  if (pu) return an;
  pu = 1;
  var e = /* @__PURE__ */ uf();
  return cf(), lf(), ff(), vf(), an = e, an;
}
var mu = {}, on, gu;
function zc() {
  if (gu) return on;
  gu = 1;
  var e = /* @__PURE__ */ Re(), r = /* @__PURE__ */ W(), t = e("Symbol"), i = t.keyFor, n = r(t.prototype.valueOf);
  return on = t.isRegisteredSymbol || function(a) {
    try {
      return i(n(a)) !== void 0;
    } catch {
      return !1;
    }
  }, on;
}
var wu;
function hf() {
  if (wu) return mu;
  wu = 1;
  var e = /* @__PURE__ */ fe(), r = /* @__PURE__ */ zc();
  return e({ target: "Symbol", stat: !0 }, {
    isRegisteredSymbol: r
  }), mu;
}
var Su = {}, sn, _u;
function Yc() {
  if (_u) return sn;
  _u = 1;
  for (var e = /* @__PURE__ */ Ze(), r = /* @__PURE__ */ Re(), t = /* @__PURE__ */ W(), i = /* @__PURE__ */ wr(), n = /* @__PURE__ */ te(), o = r("Symbol"), a = o.isWellKnownSymbol, u = r("Object", "getOwnPropertyNames"), s = t(o.prototype.valueOf), c = e("wks"), f = 0, v = u(o), p = v.length; f < p; f++)
    try {
      var m = v[f];
      i(o[m]) && n(m);
    } catch {
    }
  return sn = function(S) {
    if (a && a(S)) return !0;
    try {
      for (var _ = s(S), R = 0, w = u(c), O = w.length; R < O; R++)
        if (c[w[R]] == _) return !0;
    } catch {
    }
    return !1;
  }, sn;
}
var Ou;
function bf() {
  if (Ou) return Su;
  Ou = 1;
  var e = /* @__PURE__ */ fe(), r = /* @__PURE__ */ Yc();
  return e({ target: "Symbol", stat: !0, forced: !0 }, {
    isWellKnownSymbol: r
  }), Su;
}
var Tu = {}, Eu;
function yf() {
  if (Eu) return Tu;
  Eu = 1;
  var e = /* @__PURE__ */ U();
  return e("customMatcher"), Tu;
}
var Ru = {}, Iu;
function pf() {
  if (Iu) return Ru;
  Iu = 1;
  var e = /* @__PURE__ */ U();
  return e("observable"), Ru;
}
var qu = {}, Pu;
function mf() {
  if (Pu) return qu;
  Pu = 1;
  var e = /* @__PURE__ */ fe(), r = /* @__PURE__ */ zc();
  return e({ target: "Symbol", stat: !0, name: "isRegisteredSymbol" }, {
    isRegistered: r
  }), qu;
}
var xu = {}, Au;
function gf() {
  if (Au) return xu;
  Au = 1;
  var e = /* @__PURE__ */ fe(), r = /* @__PURE__ */ Yc();
  return e({ target: "Symbol", stat: !0, name: "isWellKnownSymbol", forced: !0 }, {
    isWellKnown: r
  }), xu;
}
var Cu = {}, ju;
function wf() {
  if (ju) return Cu;
  ju = 1;
  var e = /* @__PURE__ */ U();
  return e("matcher"), Cu;
}
var Du = {}, ku;
function Sf() {
  if (ku) return Du;
  ku = 1;
  var e = /* @__PURE__ */ U();
  return e("metadataKey"), Du;
}
var Fu = {}, Nu;
function _f() {
  if (Nu) return Fu;
  Nu = 1;
  var e = /* @__PURE__ */ U();
  return e("patternMatch"), Fu;
}
var Mu = {}, Lu;
function Of() {
  if (Lu) return Mu;
  Lu = 1;
  var e = /* @__PURE__ */ U();
  return e("replaceAll"), Mu;
}
var un, Bu;
function Tf() {
  if (Bu) return un;
  Bu = 1;
  var e = /* @__PURE__ */ df();
  return hf(), bf(), yf(), pf(), mf(), gf(), wf(), Sf(), _f(), Of(), un = e, un;
}
var cn, $u;
function Ef() {
  return $u || ($u = 1, cn = /* @__PURE__ */ Tf()), cn;
}
var Rf = /* @__PURE__ */ Ef();
const Pr = /* @__PURE__ */ Fr(Rf);
var Uu = {}, ln, Ku;
function If() {
  if (Ku) return ln;
  Ku = 1;
  var e = /* @__PURE__ */ W(), r = /* @__PURE__ */ zn(), t = /* @__PURE__ */ Tr(), i = /* @__PURE__ */ Mr(), n = e("".charAt), o = e("".charCodeAt), a = e("".slice), u = function(s) {
    return function(c, f) {
      var v = t(i(c)), p = r(f), m = v.length, g, S;
      return p < 0 || p >= m ? s ? "" : void 0 : (g = o(v, p), g < 55296 || g > 56319 || p + 1 === m || (S = o(v, p + 1)) < 56320 || S > 57343 ? s ? n(v, p) : g : s ? a(v, p, p + 2) : (g - 55296 << 10) + (S - 56320) + 65536);
    };
  };
  return ln = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: u(!1),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: u(!0)
  }, ln;
}
var Gu;
function qf() {
  if (Gu) return Uu;
  Gu = 1;
  var e = If().charAt, r = /* @__PURE__ */ Tr(), t = /* @__PURE__ */ ea(), i = /* @__PURE__ */ Gc(), n = /* @__PURE__ */ Wc(), o = "String Iterator", a = t.set, u = t.getterFor(o);
  return i(String, "String", function(s) {
    a(this, {
      type: o,
      string: r(s),
      index: 0
    });
  }, function() {
    var c = u(this), f = c.string, v = c.index, p;
    return v >= f.length ? n(void 0, !0) : (p = e(f, v), c.index += p.length, n(p, !1));
  }), Uu;
}
var fn, Wu;
function Pf() {
  if (Wu) return fn;
  Wu = 1, Vc(), qf(), Bc();
  var e = /* @__PURE__ */ Kr();
  return fn = e.f("iterator"), fn;
}
var vn, Vu;
function xf() {
  if (Vu) return vn;
  Vu = 1;
  var e = /* @__PURE__ */ Pf();
  return Hc(), vn = e, vn;
}
var dn, Hu;
function Af() {
  if (Hu) return dn;
  Hu = 1;
  var e = /* @__PURE__ */ xf();
  return dn = e, dn;
}
var hn, zu;
function Cf() {
  if (zu) return hn;
  zu = 1;
  var e = /* @__PURE__ */ Af();
  return hn = e, hn;
}
var bn, Yu;
function jf() {
  return Yu || (Yu = 1, bn = /* @__PURE__ */ Cf()), bn;
}
var Df = /* @__PURE__ */ jf();
const kf = /* @__PURE__ */ Fr(Df);
function br(e) {
  "@babel/helpers - typeof";
  return br = typeof Pr == "function" && typeof kf == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Pr == "function" && r.constructor === Pr && r !== Pr.prototype ? "symbol" : typeof r;
  }, br(e);
}
var yn, Qu;
function Ff() {
  if (Qu) return yn;
  Qu = 1, $c();
  var e = /* @__PURE__ */ Kr();
  return yn = e.f("toPrimitive"), yn;
}
var pn, Xu;
function Nf() {
  if (Xu) return pn;
  Xu = 1;
  var e = /* @__PURE__ */ Ff();
  return pn = e, pn;
}
var mn, Ju;
function Mf() {
  if (Ju) return mn;
  Ju = 1;
  var e = /* @__PURE__ */ Nf();
  return mn = e, mn;
}
var gn, Zu;
function Lf() {
  if (Zu) return gn;
  Zu = 1;
  var e = /* @__PURE__ */ Mf();
  return gn = e, gn;
}
var wn, ec;
function Bf() {
  return ec || (ec = 1, wn = /* @__PURE__ */ Lf()), wn;
}
var $f = /* @__PURE__ */ Bf();
const Uf = /* @__PURE__ */ Fr($f);
function Kf(e, r) {
  if (br(e) != "object" || !e) return e;
  var t = e[Uf];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (br(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function Gf(e) {
  var r = Kf(e, "string");
  return br(r) == "symbol" ? r : r + "";
}
function F(e, r, t) {
  return (r = Gf(r)) in e ? hl(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
var Wf = "2.0.3", Dn = 500, rc = "user-agent", ze = "", tc = "?", Dr = "function", xe = "undefined", Ye = "object", kn = "string", J = "browser", _e = "cpu", be = "device", ve = "engine", ce = "os", Ve = "result", b = "name", l = "type", h = "vendor", y = "version", Z = "architecture", yr = "major", d = "model", vr = "console", T = "mobile", D = "tablet", G = "smarttv", he = "wearable", Sn = "xr", dr = "embedded", ar = "inapp", ra = "brands", Fe = "formFactors", ta = "fullVersionList", He = "platform", ia = "platformVersion", Wr = "bitness", Ae = "sec-ch-ua", Vf = Ae + "-full-version-list", Hf = Ae + "-arch", zf = Ae + "-" + Wr, Yf = Ae + "-form-factors", Qf = Ae + "-" + T, Xf = Ae + "-" + d, Qc = Ae + "-" + He, Jf = Qc + "-version", Xc = [ra, ta, T, d, He, ia, Z, Fe, Wr], xr = "Amazon", Ke = "Apple", ic = "ASUS", nc = "BlackBerry", ke = "Google", ac = "Huawei", oc = "Lenovo", sc = "Honor", Ar = "LG", _n = "Microsoft", On = "Motorola", Tn = "Nvidia", uc = "OnePlus", En = "OPPO", or = "Samsung", cc = "Sharp", sr = "Sony", Rn = "Xiaomi", In = "Zebra", lc = "Chrome", fc = "Chromium", Ie = "Chromecast", Zf = "Edge", ur = "Firefox", cr = "Opera", qn = "Facebook", vc = "Sogou", Ge = "Mobile ", lr = " Browser", Fn = "Windows", ev = typeof window !== xe, ee = ev && window.navigator ? window.navigator : void 0, qe = ee && ee.userAgentData ? ee.userAgentData : void 0, rv = function(e, r) {
  var t = {}, i = r;
  if (!kr(r)) {
    i = {};
    for (var n in r)
      for (var o in r[n])
        i[o] = r[n][o].concat(i[o] ? i[o] : []);
  }
  for (var a in e)
    t[a] = i[a] && i[a].length % 2 === 0 ? i[a].concat(e[a]) : e[a];
  return t;
}, Vr = function(e) {
  for (var r = {}, t = 0; t < e.length; t++)
    r[e[t].toUpperCase()] = e[t];
  return r;
}, Nn = function(e, r) {
  if (typeof e === Ye && e.length > 0) {
    for (var t in e)
      if (Oe(e[t]) == Oe(r)) return !0;
    return !1;
  }
  return rr(e) ? Oe(r).indexOf(Oe(e)) !== -1 : !1;
}, kr = function(e, r) {
  for (var t in e)
    return /^(browser|cpu|device|engine|os)$/.test(t) || (r ? kr(e[t]) : !1);
}, rr = function(e) {
  return typeof e === kn;
}, Pn = function(e) {
  if (e) {
    for (var r = [], t = Qe(/\\?\"/g, e).split(","), i = 0; i < t.length; i++)
      if (t[i].indexOf(";") > -1) {
        var n = pr(t[i]).split(";v=");
        r[i] = { brand: n[0], version: n[1] };
      } else
        r[i] = pr(t[i]);
    return r;
  }
}, Oe = function(e) {
  return rr(e) ? e.toLowerCase() : e;
}, xn = function(e) {
  return rr(e) ? Qe(/[^\d\.]/g, e).split(".")[0] : void 0;
}, Te = function(e) {
  for (var r in e) {
    var t = e[r];
    typeof t == Ye && t.length == 2 ? this[t[0]] = t[1] : this[t] = void 0;
  }
  return this;
}, Qe = function(e, r) {
  return rr(r) ? r.replace(e, ze) : r;
}, fr = function(e) {
  return Qe(/\\?\"/g, e);
}, pr = function(e, r) {
  if (rr(e))
    return e = Qe(/^\s\s*/, e), typeof r === xe ? e : e.substring(0, Dn);
}, An = function(e, r) {
  if (!(!e || !r))
    for (var t = 0, i, n, o, a, u, s; t < r.length && !u; ) {
      var c = r[t], f = r[t + 1];
      for (i = n = 0; i < c.length && !u && c[i]; )
        if (u = c[i++].exec(e), u)
          for (o = 0; o < f.length; o++)
            s = u[++n], a = f[o], typeof a === Ye && a.length > 0 ? a.length === 2 ? typeof a[1] == Dr ? this[a[0]] = a[1].call(this, s) : this[a[0]] = a[1] : a.length === 3 ? typeof a[1] === Dr && !(a[1].exec && a[1].test) ? this[a[0]] = s ? a[1].call(this, s, a[2]) : void 0 : this[a[0]] = s ? s.replace(a[1], a[2]) : void 0 : a.length === 4 && (this[a[0]] = s ? a[3].call(this, s.replace(a[1], a[2])) : void 0) : this[a] = s || void 0;
      t += 2;
    }
}, Pe = function(e, r) {
  for (var t in r)
    if (typeof r[t] === Ye && r[t].length > 0) {
      for (var i = 0; i < r[t].length; i++)
        if (Nn(r[t][i], e))
          return t === tc ? void 0 : t;
    } else if (Nn(r[t], e))
      return t === tc ? void 0 : t;
  return r.hasOwnProperty("*") ? r["*"] : e;
}, dc = {
  ME: "4.90",
  "NT 3.11": "NT3.51",
  "NT 4.0": "NT4.0",
  2e3: "NT 5.0",
  XP: ["NT 5.1", "NT 5.2"],
  Vista: "NT 6.0",
  7: "NT 6.1",
  8: "NT 6.2",
  "8.1": "NT 6.3",
  10: ["NT 6.4", "NT 10.0"],
  RT: "ARM"
}, hc = {
  embedded: "Automotive",
  mobile: "Mobile",
  tablet: ["Tablet", "EInk"],
  smarttv: "TV",
  wearable: "Watch",
  xr: ["VR", "XR"],
  "?": ["Desktop", "Unknown"],
  "*": void 0
}, bc = {
  browser: [
    [
      // Most common regardless engine
      /\b(?:crmo|crios)\/([\w\.]+)/i
      // Chrome for Android/iOS
    ],
    [y, [b, Ge + "Chrome"]],
    [
      /edg(?:e|ios|a)?\/([\w\.]+)/i
      // Microsoft Edge
    ],
    [y, [b, "Edge"]],
    [
      // Presto based
      /(opera mini)\/([-\w\.]+)/i,
      // Opera Mini
      /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
      // Opera Mobi/Tablet
      /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
      // Opera
    ],
    [b, y],
    [
      /opios[\/ ]+([\w\.]+)/i
      // Opera mini on iphone >= 8.0
    ],
    [y, [b, cr + " Mini"]],
    [
      /\bop(?:rg)?x\/([\w\.]+)/i
      // Opera GX
    ],
    [y, [b, cr + " GX"]],
    [
      /\bopr\/([\w\.]+)/i
      // Opera Webkit
    ],
    [y, [b, cr]],
    [
      // Mixed
      /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
      // Baidu
    ],
    [y, [b, "Baidu"]],
    [
      /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
      // Maxthon
    ],
    [y, [b, "Maxthon"]],
    [
      /(kindle)\/([\w\.]+)/i,
      // Kindle
      /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
      // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
      // Trident based
      /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
      // Avant/IEMobile/SlimBrowser/SlimBoat/Slimjet
      /(?:ms|\()(ie) ([\w\.]+)/i,
      // Internet Explorer
      // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon/LG Browser/Otter/qutebrowser/Dooble
      /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon|otter|dooble|(?:lg |qute)browser)\/([-\w\.]+)/i,
      // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
      /(heytap|ovi|115|surf)browser\/([\d\.]+)/i,
      // HeyTap/Ovi/115/Surf
      /(ecosia|weibo)(?:__| \w+@)([\d\.]+)/i
      // Ecosia/Weibo
    ],
    [b, y],
    [
      /quark(?:pc)?\/([-\w\.]+)/i
      // Quark
    ],
    [y, [b, "Quark"]],
    [
      /\bddg\/([\w\.]+)/i
      // DuckDuckGo
    ],
    [y, [b, "DuckDuckGo"]],
    [
      /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
      // UCBrowser
    ],
    [y, [b, "UCBrowser"]],
    [
      /microm.+\bqbcore\/([\w\.]+)/i,
      // WeChat Desktop for Windows Built-in Browser
      /\bqbcore\/([\w\.]+).+microm/i,
      /micromessenger\/([\w\.]+)/i
      // WeChat
    ],
    [y, [b, "WeChat"]],
    [
      /konqueror\/([\w\.]+)/i
      // Konqueror
    ],
    [y, [b, "Konqueror"]],
    [
      /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
      // IE11
    ],
    [y, [b, "IE"]],
    [
      /ya(?:search)?browser\/([\w\.]+)/i
      // Yandex
    ],
    [y, [b, "Yandex"]],
    [
      /slbrowser\/([\w\.]+)/i
      // Smart Lenovo Browser
    ],
    [y, [b, "Smart " + oc + lr]],
    [
      /(avast|avg)\/([\w\.]+)/i
      // Avast/AVG Secure Browser
    ],
    [[b, /(.+)/, "$1 Secure" + lr], y],
    [
      /\bfocus\/([\w\.]+)/i
      // Firefox Focus
    ],
    [y, [b, ur + " Focus"]],
    [
      /\bopt\/([\w\.]+)/i
      // Opera Touch
    ],
    [y, [b, cr + " Touch"]],
    [
      /coc_coc\w+\/([\w\.]+)/i
      // Coc Coc Browser
    ],
    [y, [b, "Coc Coc"]],
    [
      /dolfin\/([\w\.]+)/i
      // Dolphin
    ],
    [y, [b, "Dolphin"]],
    [
      /coast\/([\w\.]+)/i
      // Opera Coast
    ],
    [y, [b, cr + " Coast"]],
    [
      /miuibrowser\/([\w\.]+)/i
      // MIUI Browser
    ],
    [y, [b, "MIUI" + lr]],
    [
      /fxios\/([\w\.-]+)/i
      // Firefox for iOS
    ],
    [y, [b, Ge + ur]],
    [
      /\bqihoobrowser\/?([\w\.]*)/i
      // 360
    ],
    [y, [b, "360"]],
    [
      /\b(qq)\/([\w\.]+)/i
      // QQ
    ],
    [[b, /(.+)/, "$1Browser"], y],
    [
      /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
    ],
    [[b, /(.+)/, "$1" + lr], y],
    [
      // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
      /samsungbrowser\/([\w\.]+)/i
      // Samsung Internet
    ],
    [y, [b, or + " Internet"]],
    [
      /metasr[\/ ]?([\d\.]+)/i
      // Sogou Explorer
    ],
    [y, [b, vc + " Explorer"]],
    [
      /(sogou)mo\w+\/([\d\.]+)/i
      // Sogou Mobile
    ],
    [[b, vc + " Mobile"], y],
    [
      /(electron)\/([\w\.]+) safari/i,
      // Electron-based App
      /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
      // Tesla
      /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
      // QQ/2345
    ],
    [b, y],
    [
      /(lbbrowser|rekonq)/i
      // LieBao Browser/Rekonq
    ],
    [b],
    [
      /ome\/([\w\.]+) \w* ?(iron) saf/i,
      // Iron
      /ome\/([\w\.]+).+qihu (360)[es]e/i
      // 360
    ],
    [y, b],
    [
      // WebView
      /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
      // Facebook App for iOS & Android
    ],
    [[b, qn], y, [l, ar]],
    [
      /(Klarna)\/([\w\.]+)/i,
      // Klarna Shopping Browser for iOS & Android
      /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
      // Kakao App
      /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
      // Naver InApp
      /(daum)apps[\/ ]([\w\.]+)/i,
      // Daum App
      /safari (line)\/([\w\.]+)/i,
      // Line App for iOS
      /\b(line)\/([\w\.]+)\/iab/i,
      // Line App for Android
      /(alipay)client\/([\w\.]+)/i,
      // Alipay
      /(twitter)(?:and| f.+e\/([\w\.]+))/i,
      // Twitter
      /(instagram|snapchat)[\/ ]([-\w\.]+)/i
      // Instagram/Snapchat
    ],
    [b, y, [l, ar]],
    [
      /\bgsa\/([\w\.]+) .*safari\//i
      // Google Search Appliance on iOS
    ],
    [y, [b, "GSA"], [l, ar]],
    [
      /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
      // TikTok
    ],
    [y, [b, "TikTok"], [l, ar]],
    [
      /\[(linkedin)app\]/i
      // LinkedIn App for iOS & Android
    ],
    [b, [l, ar]],
    [
      /(chromium)[\/ ]([-\w\.]+)/i
      // Chromium
    ],
    [b, y],
    [
      /headlesschrome(?:\/([\w\.]+)| )/i
      // Chrome Headless
    ],
    [y, [b, lc + " Headless"]],
    [
      / wv\).+(chrome)\/([\w\.]+)/i
      // Chrome WebView
    ],
    [[b, lc + " WebView"], y],
    [
      /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
      // Android Browser
    ],
    [y, [b, "Android" + lr]],
    [
      /chrome\/([\w\.]+) mobile/i
      // Chrome Mobile
    ],
    [y, [b, Ge + "Chrome"]],
    [
      /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
      // Chrome/OmniWeb/Arora/Tizen/Nokia
    ],
    [b, y],
    [
      /version\/([\w\.\,]+) .*mobile(?:\/\w+ | ?)safari/i
      // Safari Mobile
    ],
    [y, [b, Ge + "Safari"]],
    [
      /iphone .*mobile(?:\/\w+ | ?)safari/i
    ],
    [[b, Ge + "Safari"]],
    [
      /version\/([\w\.\,]+) .*(safari)/i
      // Safari
    ],
    [y, b],
    [
      /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
      // Safari < 3.0
    ],
    [b, [y, "1"]],
    [
      /(webkit|khtml)\/([\w\.]+)/i
    ],
    [b, y],
    [
      // Gecko based
      /(?:mobile|tablet);.*(firefox)\/([\w\.-]+)/i
      // Firefox Mobile
    ],
    [[b, Ge + ur], y],
    [
      /(navigator|netscape\d?)\/([-\w\.]+)/i
      // Netscape
    ],
    [[b, "Netscape"], y],
    [
      /(wolvic|librewolf)\/([\w\.]+)/i
      // Wolvic/LibreWolf
    ],
    [b, y],
    [
      /mobile vr; rv:([\w\.]+)\).+firefox/i
      // Firefox Reality
    ],
    [y, [b, ur + " Reality"]],
    [
      /ekiohf.+(flow)\/([\w\.]+)/i,
      // Flow
      /(swiftfox)/i,
      // Swiftfox
      /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
      // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
      /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
      // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
      /(firefox)\/([\w\.]+)/i,
      // Other Firefox-based
      /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
      // Mozilla
      // Other
      /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
      // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
      /\b(links) \(([\w\.]+)/i
      // Links
    ],
    [b, [y, /_/g, "."]],
    [
      /(cobalt)\/([\w\.]+)/i
      // Cobalt
    ],
    [b, [y, /[^\d\.]+./, ze]]
  ],
  cpu: [
    [
      /\b((amd|x|x86[-_]?|wow|win)64)\b/i
      // AMD64 (x64)
    ],
    [[Z, "amd64"]],
    [
      /(ia32(?=;))/i,
      // IA32 (quicktime)
      /\b((i[346]|x)86)(pc)?\b/i
      // IA32 (x86)
    ],
    [[Z, "ia32"]],
    [
      /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
      // ARM64
    ],
    [[Z, "arm64"]],
    [
      /\b(arm(v[67])?ht?n?[fl]p?)\b/i
      // ARMHF
    ],
    [[Z, "armhf"]],
    [
      // PocketPC mistakenly identified as PowerPC
      /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
    ],
    [[Z, "arm"]],
    [
      /((ppc|powerpc)(64)?)( mac|;|\))/i
      // PowerPC
    ],
    [[Z, /ower/, ze, Oe]],
    [
      / sun4\w[;\)]/i
      // SPARC
    ],
    [[Z, "sparc"]],
    [
      /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
      // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
    ],
    [[Z, Oe]]
  ],
  device: [
    [
      //////////////////////////
      // MOBILES & TABLETS
      /////////////////////////
      // Samsung
      /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
    ],
    [d, [h, or], [l, D]],
    [
      /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
      /samsung[- ]((?!sm-[lr])[-\w]+)/i,
      /sec-(sgh\w+)/i
    ],
    [d, [h, or], [l, T]],
    [
      // Apple
      /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
      // iPod/iPhone
    ],
    [d, [h, Ke], [l, T]],
    [
      /\((ipad);[-\w\),; ]+apple/i,
      // iPad
      /applecoremedia\/[\w\.]+ \((ipad)/i,
      /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
    ],
    [d, [h, Ke], [l, D]],
    [
      /(macintosh);/i
    ],
    [d, [h, Ke]],
    [
      // Sharp
      /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
    ],
    [d, [h, cc], [l, T]],
    [
      // Honor
      /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
    ],
    [d, [h, sc], [l, D]],
    [
      /honor([-\w ]+)[;\)]/i
    ],
    [d, [h, sc], [l, T]],
    [
      // Huawei
      /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
    ],
    [d, [h, ac], [l, D]],
    [
      /(?:huawei)([-\w ]+)[;\)]/i,
      /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
    ],
    [d, [h, ac], [l, T]],
    [
      // Xiaomi
      /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
      /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
      // Mi Pad tablets
    ],
    [[d, /_/g, " "], [h, Rn], [l, D]],
    [
      /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
      // Xiaomi POCO
      /\b; (\w+) build\/hm\1/i,
      // Xiaomi Hongmi 'numeric' models
      /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
      // Xiaomi Hongmi
      /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
      // Xiaomi Redmi
      /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
      // Xiaomi Redmi 'numeric' models
      /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
      // Xiaomi Mi
      / ([\w ]+) miui\/v?\d/i
    ],
    [[d, /_/g, " "], [h, Rn], [l, T]],
    [
      // OPPO
      /; (\w+) bui.+ oppo/i,
      /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
    ],
    [d, [h, En], [l, T]],
    [
      /\b(opd2(\d{3}a?))(?: bui|\))/i
    ],
    [d, [h, Pe, { OnePlus: ["304", "403", "203"], "*": En }], [l, D]],
    [
      // BLU Vivo Series
      /(vivo (5r?|6|8l?|go|one|s|x[il]?[2-4]?)[\w\+ ]*)(?: bui|\))/i
    ],
    [d, [h, "BLU"], [l, T]],
    [
      // Vivo
      /; vivo (\w+)(?: bui|\))/i,
      /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
    ],
    [d, [h, "Vivo"], [l, T]],
    [
      // Realme
      /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
    ],
    [d, [h, "Realme"], [l, T]],
    [
      // Motorola
      /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
      /\bmot(?:orola)?[- ](\w*)/i,
      /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
    ],
    [d, [h, On], [l, T]],
    [
      /\b(mz60\d|xoom[2 ]{0,2}) build\//i
    ],
    [d, [h, On], [l, D]],
    [
      // LG
      /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
    ],
    [d, [h, Ar], [l, D]],
    [
      /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
      /\blg[-e;\/ ]+(?!.*(?:browser|netcast|android tv|watch))(\w+)/i,
      /\blg-?([\d\w]+) bui/i
    ],
    [d, [h, Ar], [l, T]],
    [
      // Lenovo
      /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
      /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
    ],
    [d, [h, oc], [l, D]],
    [
      // Nokia
      /(nokia) (t[12][01])/i
    ],
    [h, d, [l, D]],
    [
      /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
      /nokia[-_ ]?(([-\w\. ]*))/i
    ],
    [[d, /_/g, " "], [l, T], [h, "Nokia"]],
    [
      // Google
      /(pixel (c|tablet))\b/i
      // Google Pixel C/Tablet
    ],
    [d, [h, ke], [l, D]],
    [
      /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
      // Google Pixel
    ],
    [d, [h, ke], [l, T]],
    [
      // Sony
      /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
    ],
    [d, [h, sr], [l, T]],
    [
      /sony tablet [ps]/i,
      /\b(?:sony)?sgp\w+(?: bui|\))/i
    ],
    [[d, "Xperia Tablet"], [h, sr], [l, D]],
    [
      // OnePlus
      / (kb2005|in20[12]5|be20[12][59])\b/i,
      /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
    ],
    [d, [h, uc], [l, T]],
    [
      // Amazon
      /(alexa)webm/i,
      /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
      // Kindle Fire without Silk / Echo Show
      /(kf[a-z]+)( bui|\)).+silk\//i
      // Kindle Fire HD
    ],
    [d, [h, xr], [l, D]],
    [
      /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
      // Fire Phone
    ],
    [[d, /(.+)/g, "Fire Phone $1"], [h, xr], [l, T]],
    [
      // BlackBerry
      /(playbook);[-\w\),; ]+(rim)/i
      // BlackBerry PlayBook
    ],
    [d, h, [l, D]],
    [
      /\b((?:bb[a-f]|st[hv])100-\d)/i,
      /\(bb10; (\w+)/i
      // BlackBerry 10
    ],
    [d, [h, nc], [l, T]],
    [
      // Asus
      /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
    ],
    [d, [h, ic], [l, D]],
    [
      / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
    ],
    [d, [h, ic], [l, T]],
    [
      // HTC
      /(nexus 9)/i
      // HTC Nexus 9
    ],
    [d, [h, "HTC"], [l, D]],
    [
      /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
      // HTC
      // ZTE
      /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
      /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
      // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
    ],
    [h, [d, /_/g, " "], [l, T]],
    [
      // TCL
      /tcl (xess p17aa)/i,
      /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])(_\w(\w|\w\w))?(\)| bui)/i
    ],
    [d, [h, "TCL"], [l, D]],
    [
      /droid [\w\.]+; (418(?:7d|8v)|5087z|5102l|61(?:02[dh]|25[adfh]|27[ai]|56[dh]|59k|65[ah])|a509dl|t(?:43(?:0w|1[adepqu])|50(?:6d|7[adju])|6(?:09dl|10k|12b|71[efho]|76[hjk])|7(?:66[ahju]|67[hw]|7[045][bh]|71[hk]|73o|76[ho]|79w|81[hks]?|82h|90[bhsy]|99b)|810[hs]))(_\w(\w|\w\w))?(\)| bui)/i
    ],
    [d, [h, "TCL"], [l, T]],
    [
      // itel
      /(itel) ((\w+))/i
    ],
    [[h, Oe], d, [l, Pe, { tablet: ["p10001l", "w7001"], "*": "mobile" }]],
    [
      // Acer
      /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
    ],
    [d, [h, "Acer"], [l, D]],
    [
      // Meizu
      /droid.+; (m[1-5] note) bui/i,
      /\bmz-([-\w]{2,})/i
    ],
    [d, [h, "Meizu"], [l, T]],
    [
      // Ulefone
      /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
    ],
    [d, [h, "Ulefone"], [l, T]],
    [
      // Energizer
      /; (energy ?\w+)(?: bui|\))/i,
      /; energizer ([\w ]+)(?: bui|\))/i
    ],
    [d, [h, "Energizer"], [l, T]],
    [
      // Cat
      /; cat (b35);/i,
      /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
    ],
    [d, [h, "Cat"], [l, T]],
    [
      // Smartfren
      /((?:new )?andromax[\w- ]+)(?: bui|\))/i
    ],
    [d, [h, "Smartfren"], [l, T]],
    [
      // Nothing
      /droid.+; (a(?:015|06[35]|142p?))/i
    ],
    [d, [h, "Nothing"], [l, T]],
    [
      // Archos
      /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
      /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
    ],
    [d, [h, "Archos"], [l, D]],
    [
      /archos ([\w ]+)( b|\))/i,
      /; (ac[3-6]\d\w{2,8})( b|\))/i
    ],
    [d, [h, "Archos"], [l, T]],
    [
      // MIXED
      /(imo) (tab \w+)/i,
      // IMO
      /(infinix) (x1101b?)/i
      // Infinix XPad
    ],
    [h, d, [l, D]],
    [
      /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
      // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
      /; (blu|hmd|imo|tcl)[_ ]([\w\+ ]+?)(?: bui|\)|; r)/i,
      // BLU/HMD/IMO/TCL
      /(hp) ([\w ]+\w)/i,
      // HP iPAQ
      /(microsoft); (lumia[\w ]+)/i,
      // Microsoft Lumia
      /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
      // Lenovo
      /(oppo) ?([\w ]+) bui/i
      // OPPO
    ],
    [h, d, [l, T]],
    [
      /(kobo)\s(ereader|touch)/i,
      // Kobo
      /(hp).+(touchpad(?!.+tablet)|tablet)/i,
      // HP TouchPad
      /(kindle)\/([\w\.]+)/i
      // Kindle
    ],
    [h, d, [l, D]],
    [
      /(surface duo)/i
      // Surface Duo
    ],
    [d, [h, _n], [l, D]],
    [
      /droid [\d\.]+; (fp\du?)(?: b|\))/i
      // Fairphone
    ],
    [d, [h, "Fairphone"], [l, T]],
    [
      /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
      // Nvidia Tablets
    ],
    [d, [h, Tn], [l, D]],
    [
      /(sprint) (\w+)/i
      // Sprint Phones
    ],
    [h, d, [l, T]],
    [
      /(kin\.[onetw]{3})/i
      // Microsoft Kin
    ],
    [[d, /\./g, " "], [h, _n], [l, T]],
    [
      /droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
      // Zebra
    ],
    [d, [h, In], [l, D]],
    [
      /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
    ],
    [d, [h, In], [l, T]],
    [
      ///////////////////
      // SMARTTVS
      ///////////////////
      /smart-tv.+(samsung)/i
      // Samsung
    ],
    [h, [l, G]],
    [
      /hbbtv.+maple;(\d+)/i
    ],
    [[d, /^/, "SmartTV"], [h, or], [l, G]],
    [
      /tcast.+(lg)e?. ([-\w]+)/i
      // LG SmartTV
    ],
    [h, d, [l, G]],
    [
      /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
    ],
    [[h, Ar], [l, G]],
    [
      /(apple) ?tv/i
      // Apple TV
    ],
    [h, [d, Ke + " TV"], [l, G]],
    [
      /crkey.*devicetype\/chromecast/i
      // Google Chromecast Third Generation
    ],
    [[d, Ie + " Third Generation"], [h, ke], [l, G]],
    [
      /crkey.*devicetype\/([^/]*)/i
      // Google Chromecast with specific device type
    ],
    [[d, /^/, "Chromecast "], [h, ke], [l, G]],
    [
      /fuchsia.*crkey/i
      // Google Chromecast Nest Hub
    ],
    [[d, Ie + " Nest Hub"], [h, ke], [l, G]],
    [
      /crkey/i
      // Google Chromecast, Linux-based or unknown
    ],
    [[d, Ie], [h, ke], [l, G]],
    [
      /(portaltv)/i
      // Facebook Portal TV
    ],
    [d, [h, qn], [l, G]],
    [
      /droid.+aft(\w+)( bui|\))/i
      // Fire TV
    ],
    [d, [h, xr], [l, G]],
    [
      /(shield \w+ tv)/i
      // Nvidia Shield TV
    ],
    [d, [h, Tn], [l, G]],
    [
      /\(dtv[\);].+(aquos)/i,
      /(aquos-tv[\w ]+)\)/i
      // Sharp
    ],
    [d, [h, cc], [l, G]],
    [
      /(bravia[\w ]+)( bui|\))/i
      // Sony
    ],
    [d, [h, sr], [l, G]],
    [
      /(mi(tv|box)-?\w+) bui/i
      // Xiaomi
    ],
    [d, [h, Rn], [l, G]],
    [
      /Hbbtv.*(technisat) (.*);/i
      // TechniSAT
    ],
    [h, d, [l, G]],
    [
      /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
      // Roku
      /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
      // HbbTV devices
    ],
    [[h, pr], [d, pr], [l, G]],
    [
      // SmartTV from Unidentified Vendors
      /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
    ],
    [d, [l, G]],
    [
      /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
    ],
    [[l, G]],
    [
      ///////////////////
      // CONSOLES
      ///////////////////
      /(ouya)/i,
      // Ouya
      /(nintendo) (\w+)/i
      // Nintendo
    ],
    [h, d, [l, vr]],
    [
      /droid.+; (shield)( bui|\))/i
      // Nvidia Portable
    ],
    [d, [h, Tn], [l, vr]],
    [
      /(playstation \w+)/i
      // Playstation
    ],
    [d, [h, sr], [l, vr]],
    [
      /\b(xbox(?: one)?(?!; xbox))[\); ]/i
      // Microsoft Xbox
    ],
    [d, [h, _n], [l, vr]],
    [
      ///////////////////
      // WEARABLES
      ///////////////////
      /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
      // Samsung Galaxy Watch
    ],
    [d, [h, or], [l, he]],
    [
      /((pebble))app/i,
      // Pebble
      /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
      // Asus ZenWatch / LG Watch / Pixel Watch
    ],
    [h, d, [l, he]],
    [
      /(ow(?:19|20)?we?[1-3]{1,3})/i
      // Oppo Watch
    ],
    [d, [h, En], [l, he]],
    [
      /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
      // Apple Watch
    ],
    [d, [h, Ke], [l, he]],
    [
      /(opwwe\d{3})/i
      // OnePlus Watch
    ],
    [d, [h, uc], [l, he]],
    [
      /(moto 360)/i
      // Motorola 360
    ],
    [d, [h, On], [l, he]],
    [
      /(smartwatch 3)/i
      // Sony SmartWatch
    ],
    [d, [h, sr], [l, he]],
    [
      /(g watch r)/i
      // LG G Watch R
    ],
    [d, [h, Ar], [l, he]],
    [
      /droid.+; (wt63?0{2,3})\)/i
    ],
    [d, [h, In], [l, he]],
    [
      ///////////////////
      // XR
      ///////////////////
      /droid.+; (glass) \d/i
      // Google Glass
    ],
    [d, [h, ke], [l, Sn]],
    [
      /(pico) (4|neo3(?: link|pro)?)/i
      // Pico
    ],
    [h, d, [l, Sn]],
    [
      /(quest( \d| pro)?s?).+vr/i
      // Meta Quest
    ],
    [d, [h, qn], [l, Sn]],
    [
      ///////////////////
      // EMBEDDED
      ///////////////////
      /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
      // Tesla
    ],
    [h, [l, dr]],
    [
      /(aeobc)\b/i
      // Echo Dot
    ],
    [d, [h, xr], [l, dr]],
    [
      /(homepod).+mac os/i
      // Apple HomePod
    ],
    [d, [h, Ke], [l, dr]],
    [
      /windows iot/i
    ],
    [[l, dr]],
    [
      ////////////////////
      // MIXED (GENERIC)
      ///////////////////
      /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+?(mobile|vr|\d) safari/i
    ],
    [d, [l, Pe, { mobile: "Mobile", xr: "VR", "*": D }]],
    [
      /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
      // Unidentifiable Tablet
    ],
    [[l, D]],
    [
      /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
      // Unidentifiable Mobile
    ],
    [[l, T]],
    [
      /droid .+?; ([\w\. -]+)( bui|\))/i
      // Generic Android Device
    ],
    [d, [h, "Generic"]]
  ],
  engine: [
    [
      /windows.+ edge\/([\w\.]+)/i
      // EdgeHTML
    ],
    [y, [b, Zf + "HTML"]],
    [
      /(arkweb)\/([\w\.]+)/i
      // ArkWeb
    ],
    [b, y],
    [
      /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
      // Blink
    ],
    [y, [b, "Blink"]],
    [
      /(presto)\/([\w\.]+)/i,
      // Presto
      /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
      // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna/Servo
      /ekioh(flow)\/([\w\.]+)/i,
      // Flow
      /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
      // KHTML/Tasman/Links
      /(icab)[\/ ]([23]\.[\d\.]+)/i,
      // iCab
      /\b(libweb)/i
      // LibWeb
    ],
    [b, y],
    [
      /ladybird\//i
    ],
    [[b, "LibWeb"]],
    [
      /rv\:([\w\.]{1,9})\b.+(gecko)/i
      // Gecko
    ],
    [y, b]
  ],
  os: [
    [
      // Windows
      /microsoft (windows) (vista|xp)/i
      // Windows (iTunes)
    ],
    [b, y],
    [
      /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
      // Windows Phone
    ],
    [b, [y, Pe, dc]],
    [
      /windows nt 6\.2; (arm)/i,
      // Windows RT
      /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
      /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
    ],
    [[y, Pe, dc], [b, Fn]],
    [
      // iOS/macOS
      /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
      // iOS
      /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
      /cfnetwork\/.+darwin/i
    ],
    [[y, /_/g, "."], [b, "iOS"]],
    [
      /(mac os x) ?([\w\. ]*)/i,
      /(macintosh|mac_powerpc\b)(?!.+haiku)/i
      // Mac OS
    ],
    [[b, "macOS"], [y, /_/g, "."]],
    [
      // Google Chromecast
      /android ([\d\.]+).*crkey/i
      // Google Chromecast, Android-based
    ],
    [y, [b, Ie + " Android"]],
    [
      /fuchsia.*crkey\/([\d\.]+)/i
      // Google Chromecast, Fuchsia-based
    ],
    [y, [b, Ie + " Fuchsia"]],
    [
      /crkey\/([\d\.]+).*devicetype\/smartspeaker/i
      // Google Chromecast, Linux-based Smart Speaker
    ],
    [y, [b, Ie + " SmartSpeaker"]],
    [
      /linux.*crkey\/([\d\.]+)/i
      // Google Chromecast, Legacy Linux-based
    ],
    [y, [b, Ie + " Linux"]],
    [
      /crkey\/([\d\.]+)/i
      // Google Chromecast, unknown
    ],
    [y, [b, Ie]],
    [
      // Mobile OSes
      /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
      // Android-x86/HarmonyOS
    ],
    [y, b],
    [
      /(ubuntu) ([\w\.]+) like android/i
      // Ubuntu Touch
    ],
    [[b, /(.+)/, "$1 Touch"], y],
    [
      // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
      /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/\.; ]?([\d\.]*)/i
    ],
    [b, y],
    [
      /\(bb(10);/i
      // BlackBerry 10
    ],
    [y, [b, nc]],
    [
      /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
      // Symbian
    ],
    [y, [b, "Symbian"]],
    [
      /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
      // Firefox OS
    ],
    [y, [b, ur + " OS"]],
    [
      /web0s;.+rt(tv)/i,
      /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
      // WebOS
    ],
    [y, [b, "webOS"]],
    [
      /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
      // watchOS
    ],
    [y, [b, "watchOS"]],
    [
      // Google ChromeOS
      /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
      // Chromium OS
    ],
    [[b, "Chrome OS"], y],
    [
      // Smart TVs
      /panasonic;(viera)/i,
      // Panasonic Viera
      /(netrange)mmh/i,
      // Netrange
      /(nettv)\/(\d+\.[\w\.]+)/i,
      // NetTV
      // Console
      /(nintendo|playstation) (\w+)/i,
      // Nintendo/Playstation
      /(xbox); +xbox ([^\);]+)/i,
      // Microsoft Xbox (360, One, X, S, Series X, Series S)
      /(pico) .+os([\w\.]+)/i,
      // Pico
      // Other
      /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
      // Joli/Palm
      /(mint)[\/\(\) ]?(\w*)/i,
      // Mint
      /(mageia|vectorlinux)[; ]/i,
      // Mageia/VectorLinux
      /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
      // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
      /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
      // Hurd/Linux
      /(gnu) ?([\w\.]*)/i,
      // GNU
      /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
      // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
      /(haiku) (\w+)/i
      // Haiku
    ],
    [b, y],
    [
      /(sunos) ?([\w\.\d]*)/i
      // Solaris
    ],
    [[b, "Solaris"], y],
    [
      /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
      // Solaris
      /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
      // AIX
      /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
      // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
      /(unix) ?([\w\.]*)/i
      // UNIX
    ],
    [b, y]
  ]
}, Cr = function() {
  var e = { init: {}, isIgnore: {}, isIgnoreRgx: {}, toString: {} };
  return Te.call(e.init, [
    [J, [b, y, yr, l]],
    [_e, [Z]],
    [be, [l, d, h]],
    [ve, [b, y]],
    [ce, [b, y]]
  ]), Te.call(e.isIgnore, [
    [J, [y, yr]],
    [ve, [y]],
    [ce, [y]]
  ]), Te.call(e.isIgnoreRgx, [
    [J, / ?browser$/i],
    [ce, / ?os$/i]
  ]), Te.call(e.toString, [
    [J, [b, y]],
    [_e, [Z]],
    [be, [h, d]],
    [ve, [b, y]],
    [ce, [b, y]]
  ]), e;
}(), tv = function(e, r) {
  var t = Cr.init[r], i = Cr.isIgnore[r] || 0, n = Cr.isIgnoreRgx[r] || 0, o = Cr.toString[r] || 0;
  function a() {
    Te.call(this, t);
  }
  return a.prototype.getItem = function() {
    return e;
  }, a.prototype.withClientHints = function() {
    return qe ? qe.getHighEntropyValues(Xc).then(function(u) {
      return e.setCH(new Jc(u, !1)).parseCH().get();
    }) : e.parseCH().get();
  }, a.prototype.withFeatureCheck = function() {
    return e.detectFeature().get();
  }, r != Ve && (a.prototype.is = function(u) {
    var s = !1;
    for (var c in this)
      if (this.hasOwnProperty(c) && !Nn(i, c) && Oe(n ? Qe(n, this[c]) : this[c]) == Oe(n ? Qe(n, u) : u)) {
        if (s = !0, u != xe) break;
      } else if (u == xe && s) {
        s = !s;
        break;
      }
    return s;
  }, a.prototype.toString = function() {
    var u = ze;
    for (var s in o)
      typeof this[o[s]] !== xe && (u += (u ? " " : ze) + this[o[s]]);
    return u || xe;
  }), qe || (a.prototype.then = function(u) {
    var s = this, c = function() {
      for (var v in s)
        s.hasOwnProperty(v) && (this[v] = s[v]);
    };
    c.prototype = {
      is: a.prototype.is,
      toString: a.prototype.toString
    };
    var f = new c();
    return u(f), f;
  }), new a();
};
function Jc(e, r) {
  if (e = e || {}, Te.call(this, Xc), r)
    Te.call(this, [
      [ra, Pn(e[Ae])],
      [ta, Pn(e[Vf])],
      [T, /\?1/.test(e[Qf])],
      [d, fr(e[Xf])],
      [He, fr(e[Qc])],
      [ia, fr(e[Jf])],
      [Z, fr(e[Hf])],
      [Fe, Pn(e[Yf])],
      [Wr, fr(e[zf])]
    ]);
  else
    for (var t in e)
      this.hasOwnProperty(t) && typeof e[t] !== xe && (this[t] = e[t]);
}
function yc(e, r, t, i) {
  return this.get = function(n) {
    return n ? this.data.hasOwnProperty(n) ? this.data[n] : void 0 : this.data;
  }, this.set = function(n, o) {
    return this.data[n] = o, this;
  }, this.setCH = function(n) {
    return this.uaCH = n, this;
  }, this.detectFeature = function() {
    if (ee && ee.userAgent == this.ua)
      switch (this.itemType) {
        case J:
          ee.brave && typeof ee.brave.isBrave == Dr && this.set(b, "Brave");
          break;
        case be:
          !this.get(l) && qe && qe[T] && this.set(l, T), this.get(d) == "Macintosh" && ee && typeof ee.standalone !== xe && ee.maxTouchPoints && ee.maxTouchPoints > 2 && this.set(d, "iPad").set(l, D);
          break;
        case ce:
          !this.get(b) && qe && qe[He] && this.set(b, qe[He]);
          break;
        case Ve:
          var n = this.data, o = function(a) {
            return n[a].getItem().detectFeature().get();
          };
          this.set(J, o(J)).set(_e, o(_e)).set(be, o(be)).set(ve, o(ve)).set(ce, o(ce));
      }
    return this;
  }, this.parseUA = function() {
    return this.itemType != Ve && An.call(this.data, this.ua, this.rgxMap), this.itemType == J && this.set(yr, xn(this.get(y))), this;
  }, this.parseCH = function() {
    var n = this.uaCH, o = this.rgxMap;
    switch (this.itemType) {
      case J:
      case ve:
        var a = n[ta] || n[ra], u;
        if (a)
          for (var s in a) {
            var c = a[s].brand || a[s], f = a[s].version;
            this.itemType == J && !/not.a.brand/i.test(c) && (!u || /chrom/i.test(u) && c != fc) && (c = Pe(c, {
              Chrome: "Google Chrome",
              Edge: "Microsoft Edge",
              "Chrome WebView": "Android WebView",
              "Chrome Headless": "HeadlessChrome",
              "Huawei Browser": "HuaweiBrowser",
              "MIUI Browser": "Miui Browser",
              "Opera Mobi": "OperaMobile",
              Yandex: "YaBrowser"
            }), this.set(b, c).set(y, f).set(yr, xn(f)), u = c), this.itemType == ve && c == fc && this.set(y, f);
          }
        break;
      case _e:
        var v = n[Z];
        v && (v && n[Wr] == "64" && (v += "64"), An.call(this.data, v + ";", o));
        break;
      case be:
        if (n[T] && this.set(l, T), n[d] && (this.set(d, n[d]), !this.get(l) || !this.get(h))) {
          var p = {};
          An.call(p, "droid 9; " + n[d] + ")", o), !this.get(l) && p.type && this.set(l, p.type), !this.get(h) && p.vendor && this.set(h, p.vendor);
        }
        if (n[Fe]) {
          var m;
          if (typeof n[Fe] != "string")
            for (var g = 0; !m && g < n[Fe].length; )
              m = Pe(n[Fe][g++], hc);
          else
            m = Pe(n[Fe], hc);
          this.set(l, m);
        }
        break;
      case ce:
        var S = n[He];
        if (S) {
          var _ = n[ia];
          S == Fn && (_ = parseInt(xn(_), 10) >= 13 ? "11" : "10"), this.set(b, S).set(y, _);
        }
        this.get(b) == Fn && n[d] == "Xbox" && this.set(b, "Xbox").set(y, void 0);
        break;
      case Ve:
        var R = this.data, w = function(O) {
          return R[O].getItem().setCH(n).parseCH().get();
        };
        this.set(J, w(J)).set(_e, w(_e)).set(be, w(be)).set(ve, w(ve)).set(ce, w(ce));
    }
    return this;
  }, Te.call(this, [
    ["itemType", e],
    ["ua", r],
    ["uaCH", i],
    ["rgxMap", t],
    ["data", tv(this, e)]
  ]), this;
}
function Ee(e, r, t) {
  if (typeof e === Ye ? (kr(e, !0) ? (typeof r === Ye && (t = r), r = e) : (t = e, r = void 0), e = void 0) : typeof e === kn && !kr(r, !0) && (t = r, r = void 0), t && typeof t.append === Dr) {
    var i = {};
    t.forEach(function(s, c) {
      i[c] = s;
    }), t = i;
  }
  if (!(this instanceof Ee))
    return new Ee(e, r, t).getResult();
  var n = typeof e === kn ? e : (
    // Passed user-agent string
    t && t[rc] ? t[rc] : (
      // User-Agent from passed headers
      ee && ee.userAgent ? ee.userAgent : (
        // navigator.userAgent
        ze
      )
    )
  ), o = new Jc(t, !0), a = r ? rv(bc, r) : bc, u = function(s) {
    return s == Ve ? function() {
      return new yc(s, n, a, o).set("ua", n).set(J, this.getBrowser()).set(_e, this.getCPU()).set(be, this.getDevice()).set(ve, this.getEngine()).set(ce, this.getOS()).get();
    } : function() {
      return new yc(s, n, a[s], o).parseUA().get();
    };
  };
  return Te.call(this, [
    ["getBrowser", u(J)],
    ["getCPU", u(_e)],
    ["getDevice", u(be)],
    ["getEngine", u(ve)],
    ["getOS", u(ce)],
    ["getResult", u(Ve)],
    ["getUA", function() {
      return n;
    }],
    ["setUA", function(s) {
      return rr(s) && (n = s.length > Dn ? pr(s, Dn) : s), this;
    }]
  ]).setUA(n), this;
}
Ee.VERSION = Wf;
Ee.BROWSER = Vr([b, y, yr, l]);
Ee.CPU = Vr([Z]);
Ee.DEVICE = Vr([d, h, l, vr, T, G, D, he, dr]);
Ee.ENGINE = Ee.OS = Vr([b, y]);
const iv = "0.9.0";
async function pc(e, r) {
  const t = new AbortController(), i = setTimeout(() => t.abort(), 1e4);
  try {
    const n = await fetch(e, {
      method: "POST",
      body: r,
      signal: t.signal
      // 超时控制
    });
    return clearTimeout(i), await n.json();
  } catch (n) {
    console.error("Analysis SDK Error:", n);
  }
}
class nv extends Event {
  constructor(r, t) {
    super(r), F(this, "newState", void 0), F(this, "oldState", void 0), F(this, "originalEvent", void 0), this.newState = t.newState, this.oldState = t.oldState, this.originalEvent = t.originalEvent;
  }
}
const Ne = "active", hr = "passive", Me = "hidden", Le = "frozen", Mn = "terminated", av = ["focus", "blur", "visibilitychange", "freeze", "resume", "pageshow", "pagehide"], ov = [[Ne, hr, Me, Mn], [Ne, hr, Me, Le], [Me, hr, Ne], [Le, Me], [Le, Ne], [Le, hr]].map((e) => e.reduce((r, t, i) => (r[t] = i, r), {})), sv = (e, r) => {
  for (let t, i = 0; t = ov[i]; ++i) {
    const n = t[e], o = t[r];
    if (n >= 0 && o >= 0 && o > n)
      return Object.keys(t).slice(n, o + 1);
  }
  return [];
}, jr = () => document.visibilityState === Me ? Me : document.hasFocus() ? Ne : hr;
class uv extends EventTarget {
  constructor() {
    super(), F(this, "safariBeforeUnloadTimeout", void 0), F(this, "state", void 0), F(this, "IS_SAFARI", void 0), this.IS_SAFARI = typeof safari == "object" && !!safari.pushNotification, this.state = jr(), this.handleEvents = this.handleEvents.bind(this), av.forEach((r) => addEventListener(r, this.handleEvents, !0)), this.IS_SAFARI && addEventListener("beforeunload", (r) => {
      this.safariBeforeUnloadTimeout = setTimeout(() => {
        r.defaultPrevented || r.returnValue.length > 0 || this.dispatchChangesIfNeeded(r, Me);
      }, 0);
    });
  }
  dispatchChangesIfNeeded(r, t) {
    if (t !== this.state) {
      const i = this.state, n = sv(i, t);
      for (let o = 0; o < n.length - 1; ++o) {
        const a = n[o], u = n[o + 1];
        this.state = u, this.dispatchEvent(new nv("statechange", {
          oldState: a,
          newState: u,
          originalEvent: r
        }));
      }
    }
  }
  handleEvents(r) {
    switch (this.IS_SAFARI && clearTimeout(this.safariBeforeUnloadTimeout), r.type) {
      case "pageshow":
      case "resume":
        this.dispatchChangesIfNeeded(r, jr());
        break;
      case "focus":
        this.dispatchChangesIfNeeded(r, Ne);
        break;
      case "blur":
        this.state === Ne && this.dispatchChangesIfNeeded(r, jr());
        break;
      case "pagehide":
        this.dispatchChangesIfNeeded(r, r.persisted ? Le : Mn);
        break;
      case "visibilitychange":
        this.state !== Le && this.state !== Mn && this.dispatchChangesIfNeeded(r, jr());
        break;
      case "freeze":
        this.dispatchChangesIfNeeded(r, Le);
        break;
    }
  }
}
const We = 1e3;
class cv {
  constructor(r, t) {
    F(this, "apiUrl", void 0), F(this, "syncInterval", 0), F(this, "serverTimestamp", 0), F(this, "baseTime", 0), F(this, "isSyncing", !1), this.apiUrl = r, t && (this.syncInterval = t), this.serverTimestamp = this.getClientTime(), this.baseTime = performance.now(), this.sync();
  }
  getSeconds(r) {
    return Math.floor(r / We);
  }
  getClientTime() {
    return (/* @__PURE__ */ new Date()).getTime();
  }
  // 同步服务器时间
  async sync() {
    if (!this.isSyncing) {
      this.isSyncing = !0;
      try {
        const r = this.getClientTime(), t = performance.now(), o = (await (await fetch(this.apiUrl, {
          headers: {
            "Content-Type": "application/json"
          },
          method: "GET"
        })).json()).data.ts * We, a = performance.now(), u = (a - t) / 2, s = u > We || u <= We ? We : u;
        s > We && console.warn("网络延迟过高，可能影响时间同步精度:", u, "秒"), o - r - u < s ? (this.baseTime = t, this.serverTimestamp = r) : (this.baseTime = a, this.serverTimestamp = o + u);
      } catch (r) {
        console.error("同步服务器时间失败:", r);
      } finally {
        this.isSyncing = !1, this.syncInterval && setTimeout(() => {
          this.sync();
        }, this.syncInterval);
      }
    }
  }
  // 获取当前服务器时间（秒级，UTC 0）
  now() {
    const r = performance.now() - this.baseTime, t = this.serverTimestamp + r;
    return this.getSeconds(t);
  }
  timestamp(r) {
    return this.getSeconds(r + this.serverTimestamp - this.baseTime);
  }
}
function Ln(...e) {
  const r = (i) => i && typeof i == "object" && !Array.isArray(i), t = {};
  for (const i of e)
    for (const n in i) {
      const o = i[n];
      r(o) && r(t[n]) ? t[n] = Ln(t[n], o) : t[n] = o;
    }
  return t;
}
const na = () => crypto?.randomUUID?.() ?? "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx".replace(/[xy]/g, (e) => {
  const r = Math.random() * 16 | 0;
  return (e === "x" ? r : r & 3 | 8).toString(16);
}), Bn = "avia_device_id", lv = () => {
  if (typeof window > "u") return "";
  let e = localStorage.getItem(Bn);
  return e || (e = na(), localStorage.setItem(Bn, e)), e;
}, fv = () => {
  if (typeof window > "u") return "";
  const e = "avia_session_id";
  let r = sessionStorage.getItem(e);
  return r || (r = na(), sessionStorage.setItem(e, r)), r;
};
function vv(e) {
  return e.replace(/([A-Z])/g, "_$1").toLowerCase();
}
const $n = (e, r, t) => {
  if (!e || typeof e == "string")
    return e;
  if (Array.isArray(e))
    return e.map((i) => $n(i, r));
  if (typeof e == "object") {
    let i = Object.entries(e).map(([n, o]) => [r(n), $n(o, r)]);
    return i = i.filter(([, n]) => n != null), Object.fromEntries(i);
  }
  return e;
}, dv = (e, r) => {
  const {
    userAgent: {
      ua: t,
      device: i,
      os: n
    },
    referer: o,
    requestId: a,
    webDeviceId: u,
    sessionId: s,
    reportFrom: c,
    language: f,
    localTimeZone: v,
    deviceTime: p,
    sdkVersion: m,
    config: g
  } = r, {
    sourceFlag: S,
    androidId: _,
    eventName: R,
    eventType: w,
    appVersion: O,
    hotVersion: E,
    deviceId: C,
    uniqueDeviceId: B,
    userId: k,
    accountId: I,
    projectId: q,
    aviaAppId: $,
    appId: j,
    bundleId: K,
    gps: ie,
    ext: V,
    networkType: Ue,
    ...Ce
  } = g, z = (ae) => {
    const {
      createdAt: oe,
      eventName: me = R,
      eventType: N = w,
      androidId: se = _,
      appVersion: ue = O,
      hotVersion: ne = E,
      deviceId: je = C,
      uniqueDeviceId: Q = B,
      userId: ge = k,
      accountId: De = I,
      projectId: Hr = q,
      aviaAppId: zr = $,
      appId: tr = j,
      bundleId: Er = K,
      gps: we = ie,
      ext: Rr = V,
      networkType: Yr = Ue,
      ...Ir
    } = ae;
    return {
      eventName: me,
      eventType: N,
      createdAt: oe,
      commonAttr: {
        sdkVersion: m,
        sessionId: s,
        appVersion: ue,
        hotVersion: ne,
        deviceId: je,
        uniqueDeviceId: Q,
        userId: ge,
        accountId: De,
        projectId: Hr,
        aviaAppId: zr,
        appId: tr,
        bundleId: Er,
        gps: we,
        ext: Rr,
        deviceInfo: {
          androidId: se,
          os: n.name,
          platformType: i.type,
          systemVersion: n.version
        },
        deviceInfoExt: {
          deviceBrand: i.vendor,
          deviceType: i.model,
          language: f,
          userAgent: t,
          networkType: Yr
        },
        positionInfo: {
          deviceTime: p,
          localTimeZone: v
        }
      },
      requestId: a,
      attr: {
        ...Ce,
        ...Ir,
        referer: o,
        webDeviceId: u
      }
    };
  };
  return JSON.stringify($n({
    event: e.map((ae) => z(ae)),
    reportFrom: c,
    sourceFlag: S
  }, vv));
};
function hv() {
  return -(/* @__PURE__ */ new Date()).getTimezoneOffset() / 60;
}
const Cn = "/amp-udp-tracking/api/v1", jn = {
  async: `${Cn}/behavior/batch`,
  realTime: `${Cn}/realtime/batch`,
  config: `${Cn}/web/cfg`
};
class bv {
  constructor() {
    F(this, "options", {
      logLevel: 0,
      delay: 3e4,
      batchSize: 30,
      maxSize: 300,
      apiUrl: "",
      realTime: !1,
      enableAutoEvent: !1
    }), F(this, "config", {}), F(this, "pathname", ""), F(this, "userAgent", {}), F(this, "lifecycle", null), F(this, "source", void 0), F(this, "referer", ""), F(this, "deviceId", ""), F(this, "sessionId", ""), F(this, "installed", !1), F(this, "eventQueue", []), F(this, "exposureEventQueue", /* @__PURE__ */ new Map()), F(this, "lifecycleQueue", /* @__PURE__ */ new Map()), F(this, "throttleTimeout", null), F(this, "time", null), F(this, "disabled", !1);
  }
  getApiUrl(r) {
    return this.options.apiUrl + r;
  }
  getBatchUrl() {
    return this.getApiUrl(this.options?.realTime ? jn.realTime : jn.async);
  }
  getPathname() {
    return globalThis.location.pathname;
  }
  logs(...r) {
    this.options.logLevel === 1 && console.log(...r);
  }
  setOptions(r) {
    if (!this.isObject(r))
      throw new Error("Tracker options must be an object");
    this.options = Ln(this.options, r);
  }
  setConfig(r) {
    if (!this.isObject(r))
      throw new Error("Tracker config must be an object");
    this.config = Ln(this.config, r);
  }
  setPrivateConfig() {
    this.deviceId = lv(), this.sessionId = fv(), this.referer = document?.referrer || "", this.pathname = this.getPathname(), this.time = new cv(this.getApiUrl(jn.config));
    const r = new Ee();
    this.userAgent = r.getResult();
  }
  addLifeCycle() {
    this.lifecycle = new uv();
    const r = (t) => {
      const {
        newState: i,
        oldState: n
      } = t;
      i === "active" ? (this.logs("lifecycle", n, "=>", i), this.update()) : i === "hidden" && (this.logs("lifecycle", n, "=>", i), this.unmount());
    };
    this.lifecycle.addEventListener("statechange", r);
  }
  isObject(r) {
    return typeof r == "object" && r !== null && Object.prototype.toString.call(r) === "[object Object]";
  }
  install(r, t) {
    this.installed || (this.setOptions(r), t && this.setConfig(t), this.setPrivateConfig(), this.addLifeCycle(), this.logs("tracker installed"), this.installed = !0, this.options.enableAutoEvent && (this.trigger({
      eventName: "device_enter",
      eventType: "login"
    }), !localStorage.getItem(Bn) && this.trigger({
      eventName: "first_open",
      eventType: "install"
    })));
  }
  update() {
    this.options.enableAutoEvent && this.trigger({
      eventName: "focus_in",
      eventType: "login"
    }), this.lifecycleQueue.size && (this.exposureEventQueue = new Map(Array.from(this.lifecycleQueue, ([r, t]) => [r, {
      ...t,
      createdAt: performance.now()
    }])), this.lifecycleQueue.clear(), this.logs("tracker updated"));
  }
  unmount() {
    this.options.enableAutoEvent && this.trigger({
      eventName: "focus_out",
      eventType: "exit"
    }), this.exposureEventQueue.size && (this.eventQueue.push(...[...this.exposureEventQueue.values()].map((r) => ({
      ...r,
      endTime: performance.now()
    }))), this.lifecycleQueue = new Map(this.exposureEventQueue), this.exposureEventQueue.clear()), this.flushEvents(!0), this.logs("tracker unmounted");
  }
  getLogEvent(r) {
    return {
      createdAt: performance.now(),
      source: this.source ? {
        ...this.source
      } : void 0,
      ...r
    };
  }
  stop() {
    this.installed && (this.disabled = !0);
  }
  start() {
    this.installed && (this.disabled = !1, this.flushEvents());
  }
  trigger(r, t) {
    if (!this.installed)
      return;
    if (r && !this.isObject(r))
      throw new Error("Tracker trigger data must be an object");
    const i = this.getLogEvent(r);
    if (t && !this.disabled) {
      pc(this.getBatchUrl(), this.getParams([i])), this.logs("「 RealTime Event 」:", i, !0);
      return;
    }
    if (this.eventQueue.push(i), this.disabled) {
      this.eventQueue.length > this.options.maxSize && (this.eventQueue = this.eventQueue.slice(0 - this.options.maxSize));
      return;
    }
    if (this.eventQueue.length >= this.options.batchSize) {
      this.flushEvents();
      return;
    }
    this.throttleTimeout || (this.throttleTimeout = setTimeout(() => {
      this.flushEvents();
    }, this.options.delay));
  }
  getParams(r) {
    const t = this.options.normalize;
    return dv(r.map((i) => (i.endTime && (i.endTime = this.time?.timestamp(i.endTime)), i.createdAt && (i.createdAt = this.time?.timestamp(i.createdAt)), t?.(i) ?? i)), {
      referer: this.referer,
      userAgent: this.userAgent,
      webDeviceId: this.deviceId,
      language: navigator.language,
      localTimeZone: hv(),
      deviceTime: this.time?.getSeconds(this.time?.getClientTime()),
      requestId: na(),
      sessionId: this.sessionId,
      reportFrom: this.options.realTime ? "sdk_web_rt" : "sdk_web",
      sdkVersion: iv,
      config: this.config
    });
  }
  flushEvents(r = !1) {
    if (this.throttleTimeout && (clearTimeout(this.throttleTimeout), this.throttleTimeout = null), this.disabled || !this.eventQueue.length)
      return;
    const t = [...this.eventQueue];
    this.eventQueue = [];
    const i = this.getParams(t), n = this.getBatchUrl();
    r && navigator.sendBeacon ? (navigator.sendBeacon(n, i), this.logs("「 sendBeacon Event 」:", JSON.stringify(t))) : (pc(n, i), this.logs("「 Tracker Event 」:", t));
  }
  click(r, t) {
    if (this.installed) {
      if (r && !this.isObject(r))
        throw new Error("Tracker click data must be an object");
      this.trigger({
        ...r,
        eventName: "click"
      }, t);
    }
  }
  exposure(r, t, i = !0, n) {
    if (!this.installed)
      return;
    if (r && !this.isObject(r))
      throw new Error("Tracker exposure data must be an object");
    if (!t && t !== 0) {
      this.trigger({
        ...r,
        eventName: "pageview"
      }, n);
      return;
    }
    if (this.exposureEventQueue.has(t)) {
      const a = this.exposureEventQueue.get(t);
      this.trigger({
        ...a,
        endTime: performance.now(),
        eventName: "pageview"
      }, n), this.exposureEventQueue.delete(t);
    }
    if (!i)
      return;
    const o = this.getLogEvent({
      ...r,
      eventName: "pageview"
    });
    this.exposureEventQueue.set(t, o);
  }
  // 在导航前执行
  navigate(r) {
    if (r && !this.isObject(r))
      throw new Error("Tracker navigate params must be an object");
    this.installed && (this.source = {
      pathname: this.getPathname(),
      ...r
    }, this.logs("navigated", this.source));
  }
  // 在导航后执行, 请勿重复执行
  routeChange(r) {
    if (typeof r != "string" || r.trim() === "")
      throw new Error("Tracker routeChange pathname must be a non-empty string");
    this.installed && (this.pathname !== this.source?.pathname && (this.source = {
      pathname: this.pathname
    }), this.pathname = r, this.logs("sourceChanged", r, this.pathname, this.source));
  }
}
export {
  cv as ServerTime,
  bv as Tracker,
  Ln as mergeConfig
};
